var Z = Object.defineProperty;
var K = (i, t, e) => t in i ? Z(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var r = (i, t, e) => (K(i, typeof t != "symbol" ? t + "" : t, e), e);
var h = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(h || {});
let X = class {
  constructor(t) {
    r(this, "http");
    r(this, "api", {
      /**
       * No description
       *
       * @tags Api
       * @name PublicV1ApiLoginCreate
       * @request POST:/auth-service/public/v1/api/login
       * @secure
       */
      publicV1ApiLoginCreate: (t, e = {}) => this.http.request({
        path: "/auth-service/public/v1/api/login",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "user", {
      /**
       * No description
       *
       * @tags AuthUser
       * @name AuthV1UserRoleUpdate
       * @request PUT:/auth-service/auth/v1/user/{id}/role
       * @secure
       */
      authV1UserRoleUpdate: (t, e, a = {}) => this.http.request({
        path: `/auth-service/auth/v1/user/${t}/role`,
        method: "PUT",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1UserResendPasswordCreate: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/user/${t}/resend-password`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV1UserIdpStatusDetail: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/user/idp-status/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1UserCreate: (t, e = {}) => this.http.request({
        path: "/auth-service/auth/v1/user",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1UserCreateInIdpCreate: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/user/${t}/create-in-idp`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV1UserDelete: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/user/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      }),
      authV1UserDetail: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/user/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1UserDetail2: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/user/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1UserIntercomDataList: (t = {}) => this.http.request({
        path: "/auth-service/auth/v1/user/intercom/data",
        method: "GET",
        secure: !0,
        format: "json",
        ...t
      }),
      authV1UserStartMasqueradingAsUpdate: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/user/start-masquerading-as/${t}`,
        method: "PUT",
        secure: !0,
        ...e
      }),
      authV1UserStopMasqueradingUpdate: (t = {}) => this.http.request({
        path: "/auth-service/auth/v1/user/stop-masquerading",
        method: "PUT",
        secure: !0,
        ...t
      }),
      authV1UserDetail3: (t, e = {}) => this.http.request({
        path: `/api/auth/v1/user/${t}`,
        method: "GET",
        secure: !0,
        ...e
      }),
      publicV1UserIdpStatusDetail: (t, e = {}) => this.http.request({
        path: `/auth-service/public/v1/user/idp-status/${t}`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1UserPasswordResendCreate: (t, e = {}) => this.http.request({
        path: "/api/auth/v1/user/password/resend",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      publicV1UserPasswordResendCreate: (t, e = {}) => this.http.request({
        path: "/auth-service/public/v1/user/password/resend",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    r(this, "externalIdp", {});
    r(this, "idpConfig", {
      /**
       * No description
       *
       * @tags Idp
       * @name PublicV1IdpConfigDetail
       * @request GET:/auth-service/public/v1/idp-config/{email}
       * @secure
       */
      publicV1IdpConfigDetail: (t, e = {}) => this.http.request({
        path: `/auth-service/public/v1/idp-config/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      publicV1IdpConfigIdpDetail: (t, e = {}) => this.http.request({
        path: `/auth-service/public/v1/idp-config/idp/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "role", {
      /**
       * No description
       *
       * @tags Role
       * @name AuthV1RoleCreate
       * @request POST:/auth-service/auth/v1/role
       * @secure
       */
      authV1RoleCreate: (t, e = {}) => this.http.request({
        path: "/auth-service/auth/v1/role",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1RoleList: (t = {}) => this.http.request({
        path: "/auth-service/auth/v1/role",
        method: "GET",
        secure: !0,
        format: "json",
        ...t
      }),
      authV1RoleDetail: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/role/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1RoleUpdate: (t, e, a = {}) => this.http.request({
        path: `/auth-service/auth/v1/role/${t}`,
        method: "PUT",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1RoleDelete: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/role/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      })
    });
    r(this, "agent", {});
    r(this, "seller", {});
    r(this, "agentRemoveHq", {});
    r(this, "jwksJson", {
      /**
       * No description
       *
       * @tags JsonWebKeySet
       * @name PublicWellKnownJwksJsonList
       * @request GET:/auth-service/public/.well-known/jwks.json
       * @secure
       */
      publicWellKnownJwksJsonList: (t = {}) => this.http.request({
        path: "/auth-service/public/.well-known/jwks.json",
        method: "GET",
        secure: !0,
        format: "json",
        ...t
      })
    });
    r(this, "office", {});
    r(this, "permission", {
      /**
       * No description
       *
       * @tags Permission
       * @name AuthV1PermissionCreate
       * @request POST:/auth-service/auth/v1/permission
       * @secure
       */
      authV1PermissionCreate: (t, e = {}) => this.http.request({
        path: "/auth-service/auth/v1/permission",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1PermissionList: (t = {}) => this.http.request({
        path: "/auth-service/auth/v1/permission",
        method: "GET",
        secure: !0,
        format: "json",
        ...t
      }),
      authV1PermissionDelete: (t, e, a = {}) => this.http.request({
        path: `/auth-service/auth/v1/permission/${t}/${e}`,
        method: "DELETE",
        secure: !0,
        ...a
      })
    });
    r(this, "source", {});
    r(this, "scope", {
      /**
       * No description
       *
       * @tags Scope
       * @name AuthV1ScopeCreate
       * @request POST:/auth-service/auth/v1/scope
       * @secure
       */
      authV1ScopeCreate: (t, e = {}) => this.http.request({
        path: "/auth-service/auth/v1/scope",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1ScopeList: (t = {}) => this.http.request({
        path: "/auth-service/auth/v1/scope",
        method: "GET",
        secure: !0,
        format: "json",
        ...t
      }),
      authV1ScopeDelete: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/scope/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      })
    });
    r(this, "termsOfService", {
      /**
       * No description
       *
       * @tags TermsOfService
       * @name AuthV1TermsOfServiceCreate
       * @request POST:/auth-service/auth/v1/terms-of-service
       * @secure
       */
      authV1TermsOfServiceCreate: (t, e = {}) => this.http.request({
        path: "/auth-service/auth/v1/terms-of-service",
        method: "POST",
        body: t,
        secure: !0,
        type: "multipart/form-data",
        ...e
      }),
      authV1TermsOfServiceForOfficeDetail: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/terms-of-service/for-office/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      publicV1TermsOfServiceForOfficeLatestDetail: (t, e = {}) => this.http.request({
        path: `/auth-service/public/v1/terms-of-service/for-office/${t}/latest`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1TermsOfServiceForOfficeLatestHasAcceptedDetail: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/terms-of-service/for-office/${t}/latest/has-accepted`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1TermsOfServiceAcceptCreate: (t, e = {}) => this.http.request({
        path: `/auth-service/auth/v1/terms-of-service/${t}/accept`,
        method: "POST",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "token", {
      /**
       * No description
       *
       * @tags Token
       * @name AuthV1TokenDetail
       * @request GET:/api/auth/v1/token/{propertyId}/{type}/{userAccess}
       * @secure
       */
      authV1TokenDetail: (t, e, a, s = {}) => this.http.request({
        path: `/api/auth/v1/token/${t}/${e}/${a}`,
        method: "GET",
        secure: !0,
        ...s
      })
    });
    r(this, "testToken", {});
    r(this, "readLayer", {
      /**
       * No description
       *
       * @tags UserOverview
       * @name AuthV1ReadLayerUserQueryCreate
       * @request POST:/auth-service/auth/v1/read-layer/user/query
       * @secure
       */
      authV1ReadLayerUserQueryCreate: (t, e = {}) => this.http.request({
        path: "/auth-service/auth/v1/read-layer/user/query",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1ReadLayerUserSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/auth-service/auth/v1/read-layer/user/suggestions",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    this.http = t;
  }
};
const Ft = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: X,
  ContentType: h
}, Symbol.toStringTag, { value: "Module" }));
var p = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(p || {});
let Y = class {
  constructor(t) {
    r(this, "http");
    /**
     * No description
     *
     * @tags CurrentUser
     * @name HqsHqsAndDomainsList
     * @request GET:/v1/hqs/HqsAndDomains
     */
    r(this, "hqsHqsAndDomainsList", (t = {}) => this.http.request({
      path: "/v1/hqs/HqsAndDomains",
      method: "GET",
      format: "json",
      ...t
    }));
    /**
     * No description
     *
     * @tags Hq
     * @name Get
     * @request GET:/v1/hq/{id}
     */
    r(this, "get", (t, e = {}) => this.http.request({
      path: `/v1/hq/${t}`,
      method: "GET",
      format: "json",
      ...e
    }));
    /**
     * No description
     *
     * @tags Hq
     * @name Get2
     * @request GET:/v1/hq/{name}
     * @originalName get
     * @duplicate
     */
    r(this, "get2", (t, e = {}) => this.http.request({
      path: `/v1/hq/${t}`,
      method: "GET",
      format: "json",
      ...e
    }));
    /**
     * No description
     *
     * @tags Hq
     * @name Get3
     * @request GET:/v1/hqs
     * @originalName get
     * @duplicate
     */
    r(this, "get3", (t = {}) => this.http.request({
      path: "/v1/hqs",
      method: "GET",
      format: "json",
      ...t
    }));
    /**
     * No description
     *
     * @tags Hq
     * @name HqListList
     * @request GET:/v1/hq/list
     */
    r(this, "hqListList", (t = {}) => this.http.request({
      path: "/v1/hq/list",
      method: "GET",
      format: "json",
      ...t
    }));
    /**
     * No description
     *
     * @tags OfficeControllerV1
     * @name OfficeDetail
     * @request GET:/v1/office/{id}
     */
    r(this, "officeDetail", (t, e = {}) => this.http.request({
      path: `/v1/office/${t}`,
      method: "GET",
      format: "json",
      ...e
    }));
    /**
     * No description
     *
     * @tags OfficeControllerV1
     * @name OfficeAddOfficeCreate
     * @request POST:/v1/office/addOffice
     */
    r(this, "officeAddOfficeCreate", (t, e = {}) => this.http.request({
      path: "/v1/office/addOffice",
      method: "POST",
      body: t,
      type: "application/json",
      ...e
    }));
    r(this, "alert", {
      /**
       * No description
       *
       * @tags Alerts
       * @name PublicV1AlertList
       * @request GET:/config-service/public/v1/alert
       */
      publicV1AlertList: (t = {}) => this.http.request({
        path: "/config-service/public/v1/alert",
        method: "GET",
        format: "json",
        ...t
      }),
      authV1AlertDelete: (t = {}) => this.http.request({
        path: "/config-service/auth/v1/alert",
        method: "DELETE",
        ...t
      }),
      authV1AlertUpdate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/alert",
        method: "PUT",
        body: t,
        type: "application/json",
        ...e
      })
    });
    r(this, "hqId", {
      /**
       * No description
       *
       * @tags ApplySettings
       * @name AuthV1ApplySettingsIntegrationsDetail
       * @request GET:/config-service/auth/v1/{hqId}/{officeId}/apply-settings/integrations
       */
      authV1ApplySettingsIntegrationsDetail: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/${t}/${e}/apply-settings/integrations`,
        method: "GET",
        format: "json",
        ...a
      })
    });
    r(this, "currentUser", {
      /**
       * No description
       *
       * @tags CurrentUser
       * @name AuthV1CurrentUserOfficesList
       * @request GET:/config-service/auth/v1/current-user/offices
       */
      authV1CurrentUserOfficesList: (t = {}) => this.http.request({
        path: "/config-service/auth/v1/current-user/offices",
        method: "GET",
        format: "json",
        ...t
      }),
      authV1CurrentUserHqAndDomainsList: (t = {}) => this.http.request({
        path: "/config-service/auth/v1/current-user/hq-and-domains",
        method: "GET",
        format: "json",
        ...t
      })
    });
    r(this, "event", {});
    r(this, "featureToggle", {
      /**
       * No description
       *
       * @tags FeatureToggle
       * @name AuthV1FeatureToggleList
       * @request GET:/config-service/auth/v1/feature-toggle
       */
      authV1FeatureToggleList: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/feature-toggle",
        method: "GET",
        query: t,
        format: "json",
        ...e
      })
    });
    r(this, "hq", {
      /**
       * No description
       *
       * @tags Hq
       * @name AuthV1HqDetail
       * @request GET:/config-service/auth/v1/hq/{id}
       */
      authV1HqDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqDetail2: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqOfficesDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq/${t}/offices`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqOfficesDetail2: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq/${t}/offices`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqList: (t = {}) => this.http.request({
        path: "/config-service/auth/v1/hq",
        method: "GET",
        format: "json",
        ...t
      }),
      authV1HqMigratedToProgramsDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq/${t}/migrated-to-programs`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqPaymentMethodDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq/${t}/payment-method`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqOfficeDetail: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq/${t}/office/${e}`,
        method: "GET",
        format: "json",
        ...a
      }),
      authV1HqOfficeCustomerConfigDetail: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq/${t}/office/${e}/customer-config`,
        method: "GET",
        format: "json",
        ...a
      }),
      authV1HqOfficeCustomerConfigDetail2: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq/${t}/office/${e}/customer-config`,
        method: "GET",
        format: "json",
        ...a
      }),
      authV1HqOfficeCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq/${t}/office/${e}`,
        method: "POST",
        ...a
      }),
      authV1HqOfficeResendOfficeMergeCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq/${t}/office/${e}/resend-office-merge`,
        method: "POST",
        ...a
      })
    });
    r(this, "offices", {
      /**
       * No description
       *
       * @tags Hq
       * @name HqOfficesDetail
       * @request GET:/v1/hq/{id}/offices
       */
      hqOfficesDetail: (t, e = {}) => this.http.request({
        path: `/v1/hq/${t}/offices`,
        method: "GET",
        format: "json",
        ...e
      }),
      hqOfficesDetail2: (t, e = {}) => this.http.request({
        path: `/v1/hq/${t}/offices`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "hqs", {});
    r(this, "hqSettings", {
      /**
       * No description
       *
       * @tags HqAccount
       * @name AuthV1HqSettingsAccountDetail
       * @request GET:/config-service/auth/v1/hq-settings/{hqId}/account
       */
      authV1HqSettingsAccountDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/account`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsCreate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/hq-settings",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1HqSettingsGeneralUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/general`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsLocalizationUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/localization`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsDomainsUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/domains`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsEmailUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/email`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsCcEmailUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/cc-email`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsTemplateUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/template`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsLegalDisclaimerUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/legal-disclaimer`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsPaymentMethodUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/payment-method`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsAdTemplatesDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/ad-templates`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsAdTemplatesCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/ad-templates`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsAdTemplatesUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/ad-templates`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsAdTemplatesDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/ad-templates/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1HqSettingsApiRequestsDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/api-requests`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsApiRequestsCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/api-requests`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsApiRequestsUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/api-requests`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsApiRequestsDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/api-requests/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1HqSettingsAttributeDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/attribute`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsAttributeUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/attribute`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsAttributeCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/attribute`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsAttributeDelete: (t, e, a, s = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/attribute/${e}/${a}`,
        method: "DELETE",
        ...s
      }),
      authV1HqSettingsCaptureDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/capture`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsCaptureUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/capture`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsCaptureCopyToOfficesCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/capture/copy-to-offices`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsChannelsDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/channels`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsFacebookChannelUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/facebook-channel`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsInstagramChannelUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/instagram-channel`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsTwitterChannelUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/twitter-channel`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsDisplayAdChannelUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/display-ad-channel`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsPriceSettingsUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/price-settings`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsCloudinaryTemplatesDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/cloudinary-templates`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsCloudinaryTemplatesCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/cloudinary-templates`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsCloudinaryTemplatesUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/cloudinary-templates`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsCloudinaryTemplatesDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/cloudinary-templates/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1HqSettingsEngageDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/engage`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsEngageAppearanceUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/engage-appearance`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsEngagePositioningUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/engage-positioning`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsEngageEnhanceUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/engage-enhance`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsEngagePrivacyUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/engage-privacy`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsEngageCcEmailUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/engage-cc-email`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsEnhanceDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/enhance`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsEnhanceUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/enhance`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsEnhanceCopyToOfficesCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/enhance/copy-to-offices`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsListingScraperDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/listing-scraper`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsListingScraperCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/listing-scraper`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsListingScraperUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/listing-scraper`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsListingScraperDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/listing-scraper/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1HqSettingsIdentifyWebsiteDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/identify-website`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsIdentifyWebsiteCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/identify-website`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsIdentifyWebsiteUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/identify-website`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsIdentifyWebsiteDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/identify-website/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1HqSettingsDetectWebsiteDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/detect-website`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsDetectWebsiteCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/detect-website`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsDetectWebsiteUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/detect-website`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsDetectWebsiteDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/detect-website/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1HqSettingsPropertyAttributesDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/property-attributes`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsPropertyAttributesCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/property-attributes`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsPropertyAttributesUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/property-attributes`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsPropertyAttributesDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/property-attributes/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1HqSettingsCleanupUrlDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/cleanup-url`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsCleanupUrlCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/cleanup-url`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsCleanupUrlUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/cleanup-url`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsCleanupUrlDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/cleanup-url/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1HqSettingsIntegrationsDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/integrations`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsFacebookIntegrationsUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/facebook-integrations`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsInstagramIntegrationsUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/instagram-integrations`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsBoostPackagesDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/boost-packages`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsDisplayAdPackagesDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/display-ad-packages`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsArchiveAllPackagesCreate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/hq-settings/archive-all-packages",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1HqSettingsBoostPackagesCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/boost-packages`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsBoostPackagesUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/boost-packages`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsBoostPackagesDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/boost-packages/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1HqSettingsDisplayAdPackagesCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/display-ad-packages`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsDisplayAdPackagesUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/display-ad-packages`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsDisplayAdPackagesDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/display-ad-packages/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1HqSettingsPublishingDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/publishing`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsHomeBoosterUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/home-booster`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsAutoPublishRuleCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/auto-publish-rule`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsAutoPublishRuleUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/auto-publish-rule`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsAutoPublishRuleDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/auto-publish-rule/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1HqSettingsPreSaleAgentBoosterUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/pre-sale-agent-booster`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsPostSaleAgentBoosterUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/post-sale-agent-booster`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsReboostUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/reboost`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsReboostRuleCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/reboost-rule`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsReboostRuleUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/reboost-rule`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsReboostRuleDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/reboost-rule/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1HqSettingsUpcomingUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/upcoming`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsCopsNoteUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/cops-note`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsUrlTemplatesDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/url-templates`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1HqSettingsUrlTemplatesListingImageUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/url-templates/listing-image`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsUrlTemplatesMultipleListingImagesUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/url-templates/multiple-listing-images`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsUrlTemplatesAgentImageUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/url-templates/agent-image`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsUrlTemplatesAgentPageUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/url-templates/agent-page`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsCopyDisplayAdPackageCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/copy-display-ad-package`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1HqSettingsCopyBoostPackageCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/hq-settings/${t}/copy-boost-package`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      })
    });
    r(this, "migration", {});
    r(this, "officeSettings", {
      /**
       * No description
       *
       * @tags OfficeAccount
       * @name AuthV1OfficeSettingsAccountDetail
       * @request GET:/config-service/auth/v1/office-settings/{officeId}/account
       */
      authV1OfficeSettingsAccountDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/account`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeSettingsGeneralUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/general`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsActivateUpdate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/office-settings/activate",
        method: "PUT",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1OfficeSettingsDeactivateUpdate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/office-settings/deactivate",
        method: "PUT",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1OfficeSettingsBillingUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/billing`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsBulkDeleteCreate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/office-settings/bulk-delete",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1OfficeSettingsEmailRecipientUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/email-recipient`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsCcEmailUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/cc-email`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsTemplateUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/template`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsLegalDisclaimerUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/legal-disclaimer`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsPaymentMethodUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/payment-method`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsMergeOfficesCreate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/office-settings/merge-offices",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1OfficeSettingsOfficeMergeCreate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/office-settings/office-merge",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1OfficeSettingsCampaignUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/campaign`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsCaptureDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/capture`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeSettingsCaptureUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/capture`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsChannelsDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/channels`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeSettingsFacebookChannelUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/facebook-channel`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsInstagramChannelUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/instagram-channel`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsDisplayAdChannelUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/display-ad-channel`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsPriceSettingsUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/price-settings`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsEnhanceDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/enhance`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeSettingsEnhanceUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/enhance`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsIntegrationsDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/integrations`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeSettingsFacebookIntegrationsUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/facebook-integrations`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsInstagramIntegrationsUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/instagram-integrations`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsBoostPackagesDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/boost-packages`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeSettingsDisplayAdPackagesDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/display-ad-packages`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeSettingsBoostPackagesCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/boost-packages`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsBoostPackagesUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/boost-packages`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsArchiveAllPackagesCreate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/office-settings/archive-all-packages",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1OfficeSettingsBoostPackagesDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/boost-packages/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1OfficeSettingsDisplayAdPackagesCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/display-ad-packages`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsDisplayAdPackagesUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/display-ad-packages`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsDisplayAdPackagesDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/display-ad-packages/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1OfficeSettingsCopyDisplayAdPackageCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/copy-display-ad-package`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsCopyBoostPackageCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/copy-boost-package`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsPublishingDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/publishing`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeSettingsHomeBoosterUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/home-booster`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsAutoPublishRuleCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/auto-publish-rule`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsAutoPublishRuleUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/auto-publish-rule`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsAutoPublishRuleDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/auto-publish-rule/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1OfficeSettingsPreSaleAgentBoosterUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/pre-sale-agent-booster`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsPostSaleAgentBoosterUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/post-sale-agent-booster`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsReboostUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/reboost`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsReboostRuleCreate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/reboost-rule`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsReboostRuleUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/reboost-rule`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsReboostRuleDelete: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/reboost-rule/${e}`,
        method: "DELETE",
        ...a
      }),
      authV1OfficeSettingsUpcomingUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/upcoming`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1OfficeSettingsCopsNoteUpdate: (t, e, a = {}) => this.http.request({
        path: `/config-service/auth/v1/office-settings/${t}/cops-note`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      })
    });
    r(this, "office", {
      /**
       * No description
       *
       * @tags OfficeControllerV1
       * @name AuthV1OfficeDetail
       * @request GET:/config-service/auth/v1/office/{id}
       */
      authV1OfficeDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeCreate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/office",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1OfficePaymentMethodDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office/${t}/payment-method`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeAliasesDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office/${t}/aliases`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeUpdateOfficeAliasCreate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/office/update-office-alias",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1OfficeMappingDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office/${t}/mapping`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeUpdateOfficeMappingCreate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/office/update-office-mapping",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1OfficeExternalIdDetail: (t, e = {}) => this.http.request({
        path: `/config-service/auth/v1/office/${t}/external-id`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1OfficeUpdateOfficeExternalIdCreate: (t, e = {}) => this.http.request({
        path: "/config-service/auth/v1/office/update-office-external-id",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      })
    });
    r(this, "officeId", {
      /**
       * No description
       *
       * @tags OfficeControllerV1
       * @name CustomerconfigDetail
       * @request GET:/v1/customerconfig/{hqId}/{officeId}
       */
      customerconfigDetail: (t, e, a = {}) => this.http.request({
        path: `/v1/customerconfig/${t}/${e}`,
        method: "GET",
        format: "json",
        ...a
      })
    });
    r(this, "product", {});
    r(this, "source", {});
    r(this, "hqsAndOfficesWithReboost", {});
    r(this, "syncOffices", {});
    r(this, "syncHqs", {});
    this.http = t;
  }
};
const Bt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Y,
  ContentType: p
}, Symbol.toStringTag, { value: "Module" }));
var u = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(u || {});
let tt = class {
  constructor(t) {
    r(this, "http");
    r(this, "ad", {});
    r(this, "businessManager", {});
    r(this, "campaign", {
      /**
       * No description
       *
       * @tags Campaign
       * @name FacebookV1CampaignCreateCreate
       * @request POST:/api/facebook/v1/campaign/Create
       */
      facebookV1CampaignCreateCreate: (t, e = {}) => this.http.request({
        path: "/api/facebook/v1/campaign/Create",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      facebookV1CampaignStatusDetail: (t, e = {}) => this.http.request({
        path: `/api/facebook/v1/campaign/status/${t}`,
        method: "GET",
        ...e
      }),
      facebookV1CampaignStateCreate: (t, e = {}) => this.http.request({
        path: "/api/facebook/v1/campaign/state",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      })
    });
    r(this, "replayPublished", {});
    r(this, "clientToken", {
      /**
       * No description
       *
       * @tags ClientToken
       * @name AuthV1ClientTokenCreate
       * @request POST:/facebook-service/auth/v1/client-token
       */
      authV1ClientTokenCreate: (t, e = {}) => this.http.request({
        path: "/facebook-service/auth/v1/client-token",
        method: "POST",
        query: t,
        ...e
      })
    });
    r(this, "constraints", {});
    r(this, "customAudience", {});
    r(this, "facebookIntegration", {
      /**
       * No description
       *
       * @tags FacebookIntegration
       * @name AuthV1FacebookIntegrationOverviewDetail
       * @request GET:/facebook-service/auth/v1/facebook-integration/overview/{hqId}
       */
      authV1FacebookIntegrationOverviewDetail: (t, e = {}) => this.http.request({
        path: `/facebook-service/auth/v1/facebook-integration/overview/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1FacebookIntegrationBusinessManagersList: (t = {}) => this.http.request({
        path: "/facebook-service/auth/v1/facebook-integration/business-managers",
        method: "GET",
        format: "json",
        ...t
      }),
      authV1FacebookIntegrationDetail: (t, e = {}) => this.http.request({
        path: `/facebook-service/auth/v1/facebook-integration/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1FacebookIntegrationDetail2: (t, e, a = {}) => this.http.request({
        path: `/facebook-service/auth/v1/facebook-integration/${t}/${e}`,
        method: "GET",
        format: "json",
        ...a
      }),
      authV1FacebookIntegrationCreate: (t, e = {}) => this.http.request({
        path: "/facebook-service/auth/v1/facebook-integration",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1FacebookIntegrationUpdate: (t, e = {}) => this.http.request({
        path: "/facebook-service/auth/v1/facebook-integration",
        method: "PUT",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1FacebookIntegrationDelete: (t, e = {}) => this.http.request({
        path: "/facebook-service/auth/v1/facebook-integration",
        method: "DELETE",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1FacebookIntegrationInstagramUpdate: (t, e = {}) => this.http.request({
        path: "/facebook-service/auth/v1/facebook-integration/instagram",
        method: "PUT",
        body: t,
        type: "application/json",
        ...e
      })
    });
    r(this, "instagramAccounts", {
      /**
       * No description
       *
       * @tags Instagram
       * @name AuthV1InstagramAccountsDetail
       * @request GET:/facebook-service/auth/v1/instagram-accounts/{adAccountId}/{businessManagerId}
       */
      authV1InstagramAccountsDetail: (t, e, a = {}) => this.http.request({
        path: `/facebook-service/auth/v1/instagram-accounts/${t}/${e}`,
        method: "GET",
        format: "json",
        ...a
      })
    });
    r(this, "instagramAccountsWithPage", {
      /**
       * No description
       *
       * @tags Instagram
       * @name AuthV1InstagramAccountsWithPageDetail
       * @request GET:/facebook-service/auth/v1/instagram-accounts-with-page/{pageUrl}/{businessManagerId}
       */
      authV1InstagramAccountsWithPageDetail: (t, e, a = {}) => this.http.request({
        path: `/facebook-service/auth/v1/instagram-accounts-with-page/${t}/${e}`,
        method: "GET",
        format: "json",
        ...a
      })
    });
    r(this, "instagram", {
      /**
       * No description
       *
       * @tags Instagram
       * @name AuthV1InstagramDetailsDetail
       * @request GET:/facebook-service/auth/v1/instagram/details/{hqId}/{officeId}
       */
      authV1InstagramDetailsDetail: (t, e, a = {}) => this.http.request({
        path: `/facebook-service/auth/v1/instagram/details/${t}/${e}`,
        method: "GET",
        ...a
      })
    });
    r(this, "offlineConversionEvents", {});
    r(this, "pageDetails", {
      /**
       * No description
       *
       * @tags Page
       * @name AuthV1PageDetailsDetail
       * @request GET:/facebook-service/auth/v1/page-details/{pageUrl}/{businessManagerId}
       */
      authV1PageDetailsDetail: (t, e, a = {}) => this.http.request({
        path: `/facebook-service/auth/v1/page-details/${t}/${e}`,
        method: "GET",
        format: "json",
        ...a
      })
    });
    r(this, "adslimit", {
      /**
       * No description
       *
       * @tags Page
       * @name AuthV1AdslimitDetail
       * @request GET:/facebook-service/auth/v1/adslimit/{pageId}/{pageName}/{adAccount}/{businessManagerId}
       */
      authV1AdslimitDetail: (t, e, a, s, o = {}) => this.http.request({
        path: `/facebook-service/auth/v1/adslimit/${t}/${e}/${a}/${s}`,
        method: "GET",
        format: "json",
        ...o
      })
    });
    r(this, "details", {
      /**
       * No description
       *
       * @tags Page
       * @name AuthV1DetailsDetail
       * @request GET:/facebook-service/auth/v1/details/{hqId}/{officeId}
       */
      authV1DetailsDetail: (t, e, a = {}) => this.http.request({
        path: `/facebook-service/auth/v1/details/${t}/${e}`,
        method: "GET",
        format: "json",
        ...a
      })
    });
    r(this, "page", {
      /**
       * No description
       *
       * @tags Page
       * @name AuthV1PageDetailsDetail
       * @request GET:/facebook-service/auth/v1/page/details/{hqId}/{officeId}
       */
      authV1PageDetailsDetail: (t, e, a = {}) => this.http.request({
        path: `/facebook-service/auth/v1/page/details/${t}/${e}`,
        method: "GET",
        format: "json",
        ...a
      }),
      authV1PagePromotionDetail: (t, e, a = {}) => this.http.request({
        path: `/facebook-service/auth/v1/page/promotion/${t}/${e}`,
        method: "GET",
        format: "json",
        ...a
      }),
      authV1PagePromotionByPageDetail: (t, e, a = {}) => this.http.request({
        path: `/facebook-service/auth/v1/page/promotion-by-page/${t}/${e}`,
        method: "GET",
        format: "json",
        ...a
      })
    });
    r(this, "validate", {});
    this.http = t;
  }
};
const Jt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: tt,
  ContentType: u
}, Symbol.toStringTag, { value: "Module" }));
var n = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(n || {});
let et = class {
  constructor(t) {
    r(this, "http");
    r(this, "bookmark", {
      /**
       * No description
       *
       * @tags Bookmark
       * @name AuthV1BookmarkAvailableDetail
       * @request GET:/template-service/auth/v1/bookmark/available/{subjectType}
       * @secure
       */
      authV1BookmarkAvailableDetail: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v1/bookmark/available/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "campaignContent", {
      /**
       * No description
       *
       * @tags CampaignContent
       * @name AuthV1CampaignContentDetail
       * @request GET:/template-service/auth/v1/campaign-content/{ownerType}/{ownerId}
       * @secure
       */
      authV1CampaignContentDetail: (t, e, a = {}) => this.http.request({
        path: `/template-service/auth/v1/campaign-content/${t}/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1CampaignContentFacebookDelete: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v1/campaign-content/facebook/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      }),
      authV1CampaignContentInstagramDelete: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v1/campaign-content/instagram/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      }),
      authV1CampaignContentTwitterDelete: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v1/campaign-content/twitter/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      }),
      authV1CampaignContentFacebookCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/campaign-content/facebook",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1CampaignContentFacebookUpdate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/campaign-content/facebook",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1CampaignContentInstagramCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/campaign-content/instagram",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1CampaignContentInstagramUpdate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/campaign-content/instagram",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1CampaignContentTwitterCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/campaign-content/twitter",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1CampaignContentTwitterUpdate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/campaign-content/twitter",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1CampaignContentFacebookDetail: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v1/campaign-content/facebook/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1CampaignContentInstagramDetail: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v1/campaign-content/instagram/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1CampaignContentTwitterDetail: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v1/campaign-content/twitter/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1CampaignContentFacebookFillCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/campaign-content/facebook/fill",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1CampaignContentInstagramFillCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/campaign-content/instagram/fill",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1CampaignContentTwitterFillCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/campaign-content/twitter/fill",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "email", {
      /**
       * No description
       *
       * @tags EmailTemplate
       * @name AuthV2EmailDetail
       * @request GET:/template-service/auth/v2/email/{ownerType}/{ownerId}
       * @secure
       */
      authV2EmailDetail: (t, e, a = {}) => this.http.request({
        path: `/template-service/auth/v2/email/${t}/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV2EmailAvailableDetail: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v2/email/available/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2EmailAvailableForTypeDetail: (t, e, a = {}) => this.http.request({
        path: `/template-service/auth/v2/email/available/${t}/for-type/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV2EmailDelete: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v2/email/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      }),
      authV2EmailDetail2: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v2/email/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2EmailCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v2/email",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV2EmailUpdate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v2/email",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    r(this, "imageTemplate", {
      /**
       * No description
       *
       * @tags ImageTemplate
       * @name AuthV2ImageTemplateDetail
       * @request GET:/template-service/auth/v2/image-template/{imageTemplateId}
       * @secure
       */
      authV2ImageTemplateDetail: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v2/image-template/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2ImageTemplateDelete: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v2/image-template/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      }),
      authV2ImageTemplateDetail2: (t, e, a = {}) => this.http.request({
        path: `/template-service/auth/v2/image-template/${t}/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV2ImageTemplateDetail3: (t, e, a, s = {}) => this.http.request({
        path: `/template-service/auth/v2/image-template/${t}/${e}/${a}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...s
      }),
      authV2ImageTemplateCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v2/image-template",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV2ImageTemplateUpdate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v2/image-template",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV2ImageTemplatePreviewCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v2/image-template/preview",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV2ImageTemplatePreviewForSubjectTypeCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v2/image-template/preview-for-subject-type",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV2ImageTemplateFillCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v2/image-template/fill",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV2ImageTemplateFillAllCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v2/image-template/fill-all",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV2ImageTemplateFillBatchCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v2/image-template/fill-batch",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV2ImageTemplateFillMultipleSubjectsCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v2/image-template/fill-multiple-subjects",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "slideShow", {
      /**
       * No description
       *
       * @tags SlideShow
       * @name AuthV1SlideShowCreateCreate
       * @request POST:/template-service/auth/v1/slide-show/create
       * @secure
       */
      authV1SlideShowCreateCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/slide-show/create",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "test", {
      /**
       * No description
       *
       * @tags Test
       * @name AuthV1TestList
       * @request GET:/template-service/auth/v1/test
       * @secure
       */
      authV1TestList: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/test",
        method: "GET",
        query: t,
        secure: !0,
        format: "json",
        ...e
      }),
      authV1TestCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/test",
        method: "POST",
        query: t,
        secure: !0,
        ...e
      }),
      authV1TestUpdate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/test",
        method: "PUT",
        query: t,
        secure: !0,
        ...e
      }),
      authV1TestWithoutObjectCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/test/without-object",
        method: "POST",
        query: t,
        secure: !0,
        ...e
      })
    });
    r(this, "trackingUrl", {
      /**
       * No description
       *
       * @tags TrackingUrl
       * @name AuthV1TrackingUrlDetail
       * @request GET:/template-service/auth/v1/tracking-url/{trackingUrlTemplateId}
       * @secure
       */
      authV1TrackingUrlDetail: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v1/tracking-url/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1TrackingUrlDelete: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v1/tracking-url/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      }),
      authV1TrackingUrlAllOnHqDetail: (t, e = {}) => this.http.request({
        path: `/template-service/auth/v1/tracking-url/all-on-hq/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1TrackingUrlCreate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/tracking-url",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1TrackingUrlUpdate: (t, e = {}) => this.http.request({
        path: "/template-service/auth/v1/tracking-url",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    this.http = t;
  }
};
const Qt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: et,
  ContentType: n
}, Symbol.toStringTag, { value: "Module" }));
var c = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(c || {});
let at = class {
  constructor(t) {
    r(this, "http");
    r(this, "validate", {
      /**
       * No description
       *
       * @tags UrlValidation
       * @name V1UrlValidateList
       * @request GET:/api/v1/url/validate
       */
      v1UrlValidateList: (t, e = {}) => this.http.request({
        path: "/api/v1/url/validate",
        method: "GET",
        query: t,
        ...e
      }),
      v1UrlValidateCreate: (t, e = {}) => this.http.request({
        path: "/api/v1/url/validate",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      v1UrlValidateDetailsCreate: (t, e = {}) => this.http.request({
        path: "/api/v1/url/validate/details",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      v1UrlValidateForceList: (t, e = {}) => this.http.request({
        path: "/api/v1/url/validate/force",
        method: "GET",
        query: t,
        ...e
      }),
      v1UrlValidateFacebookList: (t, e = {}) => this.http.request({
        path: "/api/v1/url/validate/facebook",
        method: "GET",
        query: t,
        ...e
      }),
      v1UrlValidateInstagramList: (t, e = {}) => this.http.request({
        path: "/api/v1/url/validate/instagram",
        method: "GET",
        query: t,
        ...e
      }),
      v1UrlValidateTwitterList: (t, e = {}) => this.http.request({
        path: "/api/v1/url/validate/twitter",
        method: "GET",
        query: t,
        ...e
      })
    });
    r(this, "validateUrl", {
      /**
       * No description
       *
       * @tags Validation
       * @name AuthV1ValidateUrlCustomLandingPageCreate
       * @request POST:/url-validation-service/auth/v1/validate-url/custom-landing-page
       */
      authV1ValidateUrlCustomLandingPageCreate: (t, e = {}) => this.http.request({
        path: "/url-validation-service/auth/v1/validate-url/custom-landing-page",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    this.http = t;
  }
};
const Zt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: at,
  ContentType: c
}, Symbol.toStringTag, { value: "Module" }));
var m = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(m || {});
let rt = class {
  constructor(t) {
    r(this, "http");
    /**
     * No description
     *
     * @tags Zendesk
     * @name ZendeskCreateOrUpdateByExternalIdCreate
     * @request POST:/api/Zendesk/CreateOrUpdateByExternalId
     */
    r(this, "zendeskCreateOrUpdateByExternalIdCreate", (t, e = {}) => this.http.request({
      path: "/api/Zendesk/CreateOrUpdateByExternalId",
      method: "POST",
      body: t,
      type: "application/json",
      ...e
    }));
    r(this, "solveTicket", {});
    r(this, "ticket", {});
    this.http = t;
  }
};
const Xt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: rt,
  ContentType: m
}, Symbol.toStringTag, { value: "Module" }));
var d = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(d || {});
let it = class {
  constructor(t) {
    r(this, "http");
    r(this, "customAttribute", {
      /**
       * No description
       *
       * @tags CustomAttribute
       * @name AuthV1CustomAttributeRemoveCreate
       * @request POST:/property-service/auth/v1/custom-attribute/remove/{hqId}/{customAttributeKey}
       */
      authV1CustomAttributeRemoveCreate: (t, e, a = {}) => this.http.request({
        path: `/property-service/auth/v1/custom-attribute/remove/${t}/${e}`,
        method: "POST",
        ...a
      })
    });
    r(this, "duplicateBlockerSettings", {
      /**
       * No description
       *
       * @tags DuplicateBlockerSettings
       * @name AuthV1DuplicateBlockerSettingsAddCreate
       * @request POST:/property-service/auth/v1/duplicate-blocker-settings/add
       */
      authV1DuplicateBlockerSettingsAddCreate: (t, e = {}) => this.http.request({
        path: "/property-service/auth/v1/duplicate-blocker-settings/add",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1DuplicateBlockerSettingsDetail: (t, e = {}) => this.http.request({
        path: `/property-service/auth/v1/duplicate-blocker-settings/${t}`,
        method: "GET",
        ...e
      })
    });
    r(this, "hqPropertyConfig", {
      /**
       * No description
       *
       * @tags HqPropertyConfig
       * @name AuthV1HqPropertyConfigCreate
       * @request POST:/property-service/auth/v1/hq-property-config
       */
      authV1HqPropertyConfigCreate: (t, e = {}) => this.http.request({
        path: "/property-service/auth/v1/hq-property-config",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1HqPropertyConfigDetail: (t, e = {}) => this.http.request({
        path: `/property-service/auth/v1/hq-property-config/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "listing", {
      /**
       * No description
       *
       * @tags Listing
       * @name AuthV1ListingUpdateListingGeocoordinateCreate
       * @request POST:/property-service/auth/v1/listing/update-listing-geocoordinate/{propertyId}
       */
      authV1ListingUpdateListingGeocoordinateCreate: (t, e, a = {}) => this.http.request({
        path: `/property-service/auth/v1/listing/update-listing-geocoordinate/${t}`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1ListingUpdateAgentLandingPageCreate: (t, e, a = {}) => this.http.request({
        path: `/property-service/auth/v1/listing/update-agent-landing-page/${t}`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1ListingUpdateCreate: (t, e = {}) => this.http.request({
        path: `/property-service/auth/v1/listing/update/${t}`,
        method: "POST",
        ...e
      })
    });
    r(this, "property", {
      /**
       * No description
       *
       * @tags Property
       * @name AuthV1PropertyResendLatestStatusCreate
       * @request POST:/property-service/auth/v1/property/{propertyId}/resend-latest-status
       */
      authV1PropertyResendLatestStatusCreate: (t, e = {}) => this.http.request({
        path: `/property-service/auth/v1/property/${t}/resend-latest-status`,
        method: "POST",
        ...e
      }),
      authV1PropertyInvalidateCachedAgentImageCreate: (t, e = {}) => this.http.request({
        path: `/property-service/auth/v1/property/${t}/invalidate-cached-agent-image`,
        method: "POST",
        ...e
      }),
      authV1PropertyInvalidateCachedMainImageCreate: (t, e = {}) => this.http.request({
        path: `/property-service/auth/v1/property/${t}/invalidate-cached-main-image`,
        method: "POST",
        ...e
      }),
      authV2PropertyDetail: (t, e = {}) => this.http.request({
        path: `/property-service/auth/v2/property/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      publicV1PropertyDetail: (t, e = {}) => this.http.request({
        path: `/property-service/public/v1/property/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "readLayer", {
      /**
       * No description
       *
       * @tags Property
       * @name AuthV1ReadLayerPropertyQueryCreate
       * @request POST:/property-service/auth/v1/read-layer/property/query
       */
      authV1ReadLayerPropertyQueryCreate: (t, e, a = {}) => this.http.request({
        path: "/property-service/auth/v1/read-layer/property/query",
        method: "POST",
        query: e,
        body: t,
        type: "application/json",
        format: "json",
        ...a
      }),
      authV1ReadLayerPropertyQueryWithCampaignsCreate: (t, e = {}) => this.http.request({
        path: "/property-service/auth/v1/read-layer/property/query/with-campaigns",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerPropertyReparseCreate: (t, e = {}) => this.http.request({
        path: "/property-service/auth/v1/read-layer/property/reparse",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerPropertyReparseSilentlyCreate: (t, e = {}) => this.http.request({
        path: "/property-service/auth/v1/read-layer/property/reparse/silently",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerPropertyRemoveCreate: (t, e = {}) => this.http.request({
        path: "/property-service/auth/v1/read-layer/property/remove",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerPropertySuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/property-service/auth/v1/read-layer/property/suggestions",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "propertyHistory", {
      /**
       * No description
       *
       * @tags PropertyHistoryV2
       * @name AuthV2PropertyHistoryDetail
       * @request GET:/property-service/auth/v2/property-history/{propertyId}
       */
      authV2PropertyHistoryDetail: (t, e = {}) => this.http.request({
        path: `/property-service/auth/v2/property-history/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "source", {});
    this.http = t;
  }
};
const te = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: it,
  ContentType: d
}, Symbol.toStringTag, { value: "Module" }));
var l = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(l || {});
let st = class {
  constructor(t) {
    r(this, "http");
    /**
     * No description
     *
     * @tags Lead
     * @name LeadCreateCreate
     * @request POST:/api/lead/Create
     */
    r(this, "leadCreateCreate", (t, e, a = {}) => this.http.request({
      path: "/api/lead/Create",
      method: "POST",
      query: e,
      body: t,
      type: "application/json",
      ...a
    }));
    /**
     * No description
     *
     * @tags TypeForm
     * @name TypeformWebhookCreate
     * @request POST:/api/typeform/Webhook
     */
    r(this, "typeformWebhookCreate", (t, e = {}) => this.http.request({
      path: "/api/typeform/Webhook",
      method: "POST",
      body: t,
      type: "application/json",
      ...e
    }));
    /**
     * No description
     *
     * @tags TypeForm
     * @name TypeformClassifyCreate
     * @request POST:/api/typeform/Classify
     */
    r(this, "typeformClassifyCreate", (t, e = {}) => this.http.request({
      path: "/api/typeform/Classify",
      method: "POST",
      body: t,
      type: "application/json",
      ...e
    }));
    r(this, "capture", {});
    r(this, "captureLead", {});
    r(this, "enhance", {});
    r(this, "from", {
      /**
       * No description
       *
       * @tags Lead
       * @name LeadPublishCrmLeadsDetail
       * @request GET:/api/lead/PublishCrmLeads/{from}/{to}
       */
      leadPublishCrmLeadsDetail: (t, e, a = {}) => this.http.request({
        path: `/api/lead/PublishCrmLeads/${t}/${e}`,
        method: "GET",
        ...a
      }),
      leadPublishLeadsToAnalyticsDetail: (t, e, a = {}) => this.http.request({
        path: `/api/lead/PublishLeadsToAnalytics/${t}/${e}`,
        method: "GET",
        ...a
      }),
      typeformGetDetail: (t, e, a, s = {}) => this.http.request({
        path: `/api/typeform/Get/${t}/${e}/${a}`,
        method: "GET",
        ...s
      })
    });
    r(this, "leadId", {
      /**
       * No description
       *
       * @tags Lead
       * @name LeadPublishLeadToAnalyticsDetail
       * @request GET:/api/lead/PublishLeadToAnalytics/{leadId}
       */
      leadPublishLeadToAnalyticsDetail: (t, e = {}) => this.http.request({
        path: `/api/lead/PublishLeadToAnalytics/${t}`,
        method: "GET",
        ...e
      })
    });
    r(this, "lead", {
      /**
       * No description
       *
       * @tags Lead
       * @name AuthV1LeadPropertyDetail
       * @request GET:/lead-service/auth/v1/Lead/property/{propertyId}
       */
      authV1LeadPropertyDetail: (t, e = {}) => this.http.request({
        path: `/lead-service/auth/v1/Lead/property/${t}`,
        method: "GET",
        ...e
      })
    });
    r(this, "leadClassifier", {});
    r(this, "classifier", {});
    r(this, "reference", {});
    r(this, "typeform", {});
    this.http = t;
  }
};
const ae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: st,
  ContentType: l
}, Symbol.toStringTag, { value: "Module" }));
var g = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(g || {});
let ot = class {
  constructor(t) {
    r(this, "http");
    /**
     * No description
     *
     * @tags StripeWebhook
     * @name StripewebhookCreate
     * @request POST:/api/stripewebhook
     * @secure
     */
    r(this, "stripewebhookCreate", (t = {}) => this.http.request({
      path: "/api/stripewebhook",
      method: "POST",
      secure: !0,
      ...t
    }));
    /**
     * No description
     *
     * @tags StripeWebhook
     * @name StripewebhookCreate2
     * @request POST:/api/stripewebhook/{market}
     * @originalName stripewebhookCreate
     * @duplicate
     * @secure
     */
    r(this, "stripewebhookCreate2", (t, e = {}) => this.http.request({
      path: `/api/stripewebhook/${t}`,
      method: "POST",
      secure: !0,
      ...e
    }));
    r(this, "customer", {
      /**
       * No description
       *
       * @tags Customer
       * @name AuthV1CustomerCreateCreditCardSetupSessionCreate
       * @request POST:/stripe-service/auth/v1/customer/create-credit-card-setup-session
       * @secure
       */
      authV1CustomerCreateCreditCardSetupSessionCreate: (t = {}) => this.http.request({
        path: "/stripe-service/auth/v1/customer/create-credit-card-setup-session",
        method: "POST",
        secure: !0,
        format: "json",
        ...t
      }),
      authV2CustomerCreateCreditCardSetupSessionCreate: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/customer/create-credit-card-setup-session/${t}`,
        method: "POST",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1CustomerSavePaymentMethodCreate: (t, e = {}) => this.http.request({
        path: "/stripe-service/auth/v1/customer/save-payment-method",
        method: "POST",
        query: t,
        secure: !0,
        ...e
      }),
      authV1CustomerRemoveCreditCardCreate: (t = {}) => this.http.request({
        path: "/stripe-service/auth/v1/customer/remove-credit-card",
        method: "POST",
        secure: !0,
        ...t
      }),
      authV1CustomerCreditCardDescriptionList: (t = {}) => this.http.request({
        path: "/stripe-service/auth/v1/customer/credit-card-description",
        method: "GET",
        secure: !0,
        format: "json",
        ...t
      })
    });
    r(this, "hqcustomer", {
      /**
       * No description
       *
       * @tags HqCustomer
       * @name AuthV2HqcustomerCreditCardDescriptionDetail
       * @request GET:/stripe-service/auth/v2/hqcustomer/credit-card-description/{hqId}
       * @secure
       */
      authV2HqcustomerCreditCardDescriptionDetail: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/hqcustomer/credit-card-description/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2HqcustomerAddPaymentMethodCreate: (t, e = {}) => this.http.request({
        path: "/stripe-service/auth/v2/hqcustomer/add-payment-method",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV2HqcustomerChangeDefaultPaymentMethodUpdate: (t, e = {}) => this.http.request({
        path: "/stripe-service/auth/v2/hqcustomer/change-default-payment-method",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV2HqcustomerRemovePaymentMethodUpdate: (t, e = {}) => this.http.request({
        path: "/stripe-service/auth/v2/hqcustomer/remove-payment-method",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV2HqcustomerPaymentMethodsDetail: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/hqcustomer/payment-methods/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2HqcustomerTransactionsDetail: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/hqcustomer/transactions/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2HqcustomerPaymentMethodsClearDefaultUpdate: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/hqcustomer/payment-methods/clear-default/${t}`,
        method: "PUT",
        secure: !0,
        ...e
      }),
      authV2HqcustomerPaymentMethodsCheckCreate: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/hqcustomer/payment-methods/check/${t}`,
        method: "POST",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2HqcustomerTransactionsGroupDetail: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/hqcustomer/transactions/${t}/group`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "invoice", {});
    r(this, "officecustomer", {
      /**
       * No description
       *
       * @tags OfficeCustomer
       * @name AuthV2OfficecustomerCreditCardDescriptionDetail
       * @request GET:/stripe-service/auth/v2/officecustomer/credit-card-description/{officeId}
       * @secure
       */
      authV2OfficecustomerCreditCardDescriptionDetail: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/officecustomer/credit-card-description/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2OfficecustomerAddPaymentMethodCreate: (t, e = {}) => this.http.request({
        path: "/stripe-service/auth/v2/officecustomer/add-payment-method",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV2OfficecustomerChangeDefaultPaymentMethodUpdate: (t, e = {}) => this.http.request({
        path: "/stripe-service/auth/v2/officecustomer/change-default-payment-method",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV2OfficecustomerRemovePaymentMethodUpdate: (t, e = {}) => this.http.request({
        path: "/stripe-service/auth/v2/officecustomer/remove-payment-method",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV2OfficecustomerPaymentMethodsDetail: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/officecustomer/payment-methods/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2OfficecustomerTransactionsDetail: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/officecustomer/transactions/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2OfficecustomerPaymentMethodsClearDefaultUpdate: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/officecustomer/payment-methods/clear-default/${t}`,
        method: "PUT",
        secure: !0,
        ...e
      }),
      authV2OfficecustomerPaymentMethodsCheckCreate: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/officecustomer/payment-methods/check/${t}`,
        method: "POST",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2OfficecustomerTransactionsGroupDetail: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v2/officecustomer/transactions/${t}/group`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "singleCharge", {
      /**
       * No description
       *
       * @tags SingleCharge
       * @name AuthV1SingleChargeSessionDetail
       * @request GET:/stripe-service/auth/v1/single-charge/{orderId}/session
       * @secure
       */
      authV1SingleChargeSessionDetail: (t, e = {}) => this.http.request({
        path: `/stripe-service/auth/v1/single-charge/${t}/session`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    this.http = t;
  }
};
const ie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: ot,
  ContentType: g
}, Symbol.toStringTag, { value: "Module" }));
var v = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(v || {});
let ht = class {
  constructor(t) {
    r(this, "http");
    r(this, "reporting", {
      /**
       * No description
       *
       * @tags EmbedReportInfo
       * @name AuthV1ReportingEmbedWorkspaceReportHqDetail
       * @request GET:/reporting-service/auth/v1/reporting/embed/workspace/{workspaceId}/report/{reportId}/hq/{hqId}
       */
      authV1ReportingEmbedWorkspaceReportHqDetail: (t, e, a, s = {}) => this.http.request({
        path: `/reporting-service/auth/v1/reporting/embed/workspace/${t}/report/${e}/hq/${a}`,
        method: "GET",
        format: "json",
        ...s
      }),
      authV1ReportingEmbedWorkspaceReportOfficeDetail: (t, e, a, s = {}) => this.http.request({
        path: `/reporting-service/auth/v1/reporting/embed/workspace/${t}/report/${e}/office/${a}`,
        method: "GET",
        format: "json",
        ...s
      }),
      authV1ReportingEmbedOfficeDetail: (t, e = {}) => this.http.request({
        path: `/reporting-service/auth/v1/reporting/embed/office/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1ReportingEmbedHqDetail: (t, e = {}) => this.http.request({
        path: `/reporting-service/auth/v1/reporting/embed/hq/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    this.http = t;
  }
};
const oe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: ht,
  ContentType: v
}, Symbol.toStringTag, { value: "Module" }));
var f = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(f || {});
let pt = class {
  constructor(t) {
    r(this, "http");
    r(this, "debug", {});
    r(this, "domainAuthentication", {
      /**
       * No description
       *
       * @tags DomainAuthentication
       * @name PublicV1DomainAuthenticationInstructionsDetail
       * @request GET:/email-service/public/v1/domain-authentication/{domainId}/instructions
       * @secure
       */
      publicV1DomainAuthenticationInstructionsDetail: (t, e = {}) => this.http.request({
        path: `/email-service/public/v1/domain-authentication/${t}/instructions`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      publicV1DomainAuthenticationStatusDetail: (t, e = {}) => this.http.request({
        path: `/email-service/public/v1/domain-authentication/${t}/status`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1DomainAuthenticationDetail: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v1/domain-authentication/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1DomainAuthenticationCreate: (t, e = {}) => this.http.request({
        path: "/email-service/auth/v1/domain-authentication",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    r(this, "mailgunCallback", {
      /**
       * No description
       *
       * @tags Email
       * @name PublicV1MailgunCallbackCreate
       * @request POST:/email-service/public/v1/mailgun-callback
       * @secure
       */
      publicV1MailgunCallbackCreate: (t = {}) => this.http.request({
        path: "/email-service/public/v1/mailgun-callback",
        method: "POST",
        secure: !0,
        ...t
      })
    });
    r(this, "sendGridCallback", {
      /**
       * No description
       *
       * @tags Email
       * @name PublicV1SendGridCallbackCreate
       * @request POST:/email-service/public/v1/send-grid-callback
       * @secure
       */
      publicV1SendGridCallbackCreate: (t = {}) => this.http.request({
        path: "/email-service/public/v1/send-grid-callback",
        method: "POST",
        secure: !0,
        ...t
      })
    });
    r(this, "email", {
      /**
       * No description
       *
       * @tags Email
       * @name AuthV1EmailLogDetail
       * @request GET:/email-service/auth/v1/email/{subjectId}/{subjectType}/log
       * @secure
       */
      authV1EmailLogDetail: (t, e, a = {}) => this.http.request({
        path: `/email-service/auth/v1/email/${t}/${e}/log`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1EmailLogCreate: (t, e = {}) => this.http.request({
        path: "/email-service/auth/v1/email/log",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV2EmailCreate: (t, e = {}) => this.http.request({
        path: "/email-service/auth/v2/email",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV2EmailDetail: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v2/email/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2EmailAllEmailDetailsOnSubjectDetail: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v2/email/all-email-details-on-subject/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "emailType", {
      /**
       * No description
       *
       * @tags EmailType
       * @name AuthV2EmailTypeCreate
       * @request POST:/email-service/auth/v2/email-type
       * @secure
       */
      authV2EmailTypeCreate: (t, e = {}) => this.http.request({
        path: "/email-service/auth/v2/email-type",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV2EmailTypeUpdate: (t, e = {}) => this.http.request({
        path: "/email-service/auth/v2/email-type",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV2EmailTypeAvailableList: (t = {}) => this.http.request({
        path: "/email-service/auth/v2/email-type/available",
        method: "GET",
        secure: !0,
        format: "json",
        ...t
      }),
      authV2EmailTypeDetail: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v2/email-type/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2EmailTypeDelete: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v2/email-type/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      }),
      authV2EmailTypeUnsubscribedDetail: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v2/email-type/unsubscribed/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2EmailTypeUnsubscribedByHqDetail: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v2/email-type/unsubscribed-by-hq/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2EmailTypeUnsubscribeCreate: (t, e, a = {}) => this.http.request({
        path: `/email-service/auth/v2/email-type/${t}/unsubscribe/${e}`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV2EmailTypeResubscribeCreate: (t, e, a = {}) => this.http.request({
        path: `/email-service/auth/v2/email-type/${t}/resubscribe/${e}`,
        method: "POST",
        secure: !0,
        ...a
      })
    });
    r(this, "recipientConfiguration", {
      /**
       * No description
       *
       * @tags RecipientConfiguration
       * @name AuthV3RecipientConfigurationCreate
       * @request POST:/email-service/auth/v3/recipient-configuration
       * @secure
       */
      authV3RecipientConfigurationCreate: (t, e = {}) => this.http.request({
        path: "/email-service/auth/v3/recipient-configuration",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV3RecipientConfigurationUpdate: (t, e = {}) => this.http.request({
        path: "/email-service/auth/v3/recipient-configuration",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV3RecipientConfigurationForOwnerDetail: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v3/recipient-configuration/for-owner/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV3RecipientConfigurationForHqDetail: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v3/recipient-configuration/for-hq/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV3RecipientConfigurationDelete: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v3/recipient-configuration/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      })
    });
    r(this, "sendgrid", {
      /**
       * No description
       *
       * @tags SendGridWebhook
       * @name PublicV1SendgridEventTrackingCreate
       * @request POST:/email-service/public/v1/sendgrid/event-tracking
       * @secure
       */
      publicV1SendgridEventTrackingCreate: (t = {}) => this.http.request({
        path: "/email-service/public/v1/sendgrid/event-tracking",
        method: "POST",
        secure: !0,
        ...t
      })
    });
    r(this, "templateConfiguration", {
      /**
       * No description
       *
       * @tags TemplateConfiguration
       * @name AuthV3TemplateConfigurationCreate
       * @request POST:/email-service/auth/v3/template-configuration
       * @secure
       */
      authV3TemplateConfigurationCreate: (t, e = {}) => this.http.request({
        path: "/email-service/auth/v3/template-configuration",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV3TemplateConfigurationUpdate: (t, e = {}) => this.http.request({
        path: "/email-service/auth/v3/template-configuration",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV3TemplateConfigurationDetail: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v3/template-configuration/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV3TemplateConfigurationDelete: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v3/template-configuration/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      }),
      authV3TemplateConfigurationForHqDetail: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v3/template-configuration/for-hq/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV3TemplateConfigurationAllForOwnerDetail: (t, e = {}) => this.http.request({
        path: `/email-service/auth/v3/template-configuration/all-for-owner/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    this.http = t;
  }
};
const pe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: pt,
  ContentType: f
}, Symbol.toStringTag, { value: "Module" }));
var q = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(q || {});
let ut = class {
  constructor(t) {
    r(this, "http");
    r(this, "campaign", {});
    r(this, "client", {});
    r(this, "deltaTemplate", {});
    r(this, "deltaTemplateSetting", {
      /**
       * No description
       *
       * @tags DeltaTemplateSetting
       * @name AuthV1DeltaTemplateSettingUpdate
       * @request PUT:/display-ads-service/auth/v1/delta-template-setting
       */
      authV1DeltaTemplateSettingUpdate: (t, e = {}) => this.http.request({
        path: "/display-ads-service/auth/v1/delta-template-setting",
        method: "PUT",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1DeltaTemplateSettingCreate: (t, e = {}) => this.http.request({
        path: "/display-ads-service/auth/v1/delta-template-setting",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1DeltaTemplateSettingDelete: (t, e = {}) => this.http.request({
        path: "/display-ads-service/auth/v1/delta-template-setting",
        method: "DELETE",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1DeltaTemplateSettingDetail: (t, e = {}) => this.http.request({
        path: `/display-ads-service/auth/v1/delta-template-setting/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "hqDeltaClient", {});
    r(this, "template", {
      /**
       * No description
       *
       * @tags Template
       * @name AuthV1TemplateList
       * @request GET:/display-ads-service/auth/v1/template
       */
      authV1TemplateList: (t = {}) => this.http.request({
        path: "/display-ads-service/auth/v1/template",
        method: "GET",
        format: "json",
        ...t
      })
    });
    this.http = t;
  }
};
const ne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: ut,
  ContentType: q
}, Symbol.toStringTag, { value: "Module" }));
var y = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(y || {});
let nt = class {
  constructor(t) {
    r(this, "http");
    /**
     * No description
     *
     * @tags TrackLead
     * @name TrackLeadList
     * @request GET:/adfenix/TrackLead
     */
    r(this, "trackLeadList", (t, e = {}) => this.http.request({
      path: "/adfenix/TrackLead",
      method: "GET",
      query: t,
      ...e
    }));
    /**
     * No description
     *
     * @tags Tracking
     * @name TrackerList
     * @request GET:/api/tracker
     */
    r(this, "trackerList", (t, e = {}) => this.http.request({
      path: "/api/tracker",
      method: "GET",
      query: t,
      ...e
    }));
    r(this, "blockedProperty", {});
    r(this, "customAttribute", {
      /**
       * No description
       *
       * @tags CustomAttribute
       * @name AuthV1CustomAttributeHqDetail
       * @request GET:/property-discovery-service/auth/v1/custom-attribute/hq/{hqId}
       */
      authV1CustomAttributeHqDetail: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/custom-attribute/hq/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV2CustomAttributeHqDetail: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v2/custom-attribute/hq/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1CustomAttributeCreate: (t, e = {}) => this.http.request({
        path: "/property-discovery-service/auth/v1/custom-attribute",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1CustomAttributeUpdate: (t, e, a = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/custom-attribute/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1CustomAttributeDelete: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/custom-attribute/${t}`,
        method: "DELETE",
        ...e
      })
    });
    r(this, "customerApiCalls", {
      /**
       * No description
       *
       * @tags CustomerApiCalls
       * @name AuthV1CustomerApiCallsHqDetail
       * @request GET:/property-discovery-service/auth/v1/customer-api-calls/hq/{hqId}
       */
      authV1CustomerApiCallsHqDetail: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/customer-api-calls/hq/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1CustomerApiCallsCreate: (t, e = {}) => this.http.request({
        path: "/property-discovery-service/auth/v1/customer-api-calls",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1CustomerApiCallsUpdate: (t, e, a = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/customer-api-calls/${t}`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1CustomerApiCallsDelete: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/customer-api-calls/${t}`,
        method: "DELETE",
        ...e
      })
    });
    r(this, "hqSettings", {
      /**
       * No description
       *
       * @tags HqSettings
       * @name AuthV1HqSettingsCreate
       * @request POST:/property-discovery-service/auth/v1/hq-settings
       */
      authV1HqSettingsCreate: (t, e = {}) => this.http.request({
        path: "/property-discovery-service/auth/v1/hq-settings",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1HqSettingsUpdate: (t, e = {}) => this.http.request({
        path: "/property-discovery-service/auth/v1/hq-settings",
        method: "PUT",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1HqSettingsDetail: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/hq-settings/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "htmlDownload", {
      /**
       * No description
       *
       * @tags HtmlDownload
       * @name AuthV1HtmlDownloadDetail
       * @request GET:/property-discovery-service/auth/v1/html-download/{propertyId}
       */
      authV1HtmlDownloadDetail: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/html-download/${t}`,
        method: "GET",
        ...e
      })
    });
    r(this, "identifier", {});
    r(this, "listings", {
      /**
       * No description
       *
       * @tags Listings
       * @name AuthV1ListingsUploadCreate
       * @request POST:/property-discovery-service/auth/v1/Listings/upload
       */
      authV1ListingsUploadCreate: (t, e = {}) => this.http.request({
        path: "/property-discovery-service/auth/v1/Listings/upload",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1ListingsUpdateCreate: (t, e = {}) => this.http.request({
        path: "/property-discovery-service/auth/v1/Listings/update",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1ListingsBlockingReasonsDetail: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/Listings/blocking-reasons/${t}`,
        method: "GET",
        ...e
      })
    });
    r(this, "parse", {
      /**
       * No description
       *
       * @tags Parse
       * @name AuthV1ParseUrlCreate
       * @request POST:/property-discovery-service/auth/v1/parse/url
       */
      authV1ParseUrlCreate: (t, e = {}) => this.http.request({
        path: "/property-discovery-service/auth/v1/parse/url",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      })
    });
    r(this, "parsingSettings", {
      /**
       * No description
       *
       * @tags ParsingSettings
       * @name AuthV1ParsingSettingsHqDetail
       * @request GET:/property-discovery-service/auth/v1/parsing-settings/hq/{hqId}
       */
      authV1ParsingSettingsHqDetail: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/parsing-settings/hq/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1ParsingSettingsPublicCreate: (t, e, a = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/parsing-settings/${t}/public`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1ParsingSettingsAdvancedCreate: (t, e, a = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/parsing-settings/${t}/advanced`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1ParsingSettingsDelete: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/parsing-settings/${t}`,
        method: "DELETE",
        ...e
      })
    });
    r(this, "property", {
      /**
       * No description
       *
       * @tags Property
       * @name AuthV1PropertyVisitorsDetail
       * @request GET:/property-discovery-service/auth/v1/Property/{propertyId}/visitors
       */
      authV1PropertyVisitorsDetail: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/Property/${t}/visitors`,
        method: "GET",
        ...e
      })
    });
    r(this, "propertyUrlScrapers", {
      /**
       * No description
       *
       * @tags PropertyUrlScrapers
       * @name AuthV1PropertyUrlScrapersDetail
       * @request GET:/property-discovery-service/auth/v1/property-url-scrapers/{hqId}
       */
      authV1PropertyUrlScrapersDetail: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/property-url-scrapers/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1PropertyUrlScrapersUpdate: (t, e = {}) => this.http.request({
        path: "/property-discovery-service/auth/v1/property-url-scrapers",
        method: "PUT",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1PropertyUrlScrapersDelete: (t, e = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/property-url-scrapers/${t}`,
        method: "DELETE",
        ...e
      })
    });
    r(this, "propertyVisit", {
      /**
       * No description
       *
       * @tags PropertyVisit
       * @name PublicV1PropertyVisitIdentifierList
       * @request GET:/property-discovery-service/public/v1/property-visit/identifier
       */
      publicV1PropertyVisitIdentifierList: (t, e = {}) => this.http.request({
        path: "/property-discovery-service/public/v1/property-visit/identifier",
        method: "GET",
        query: t,
        ...e
      }),
      publicV1PropertyVisitList: (t, e = {}) => this.http.request({
        path: "/property-discovery-service/public/v1/property-visit",
        method: "GET",
        query: t,
        ...e
      })
    });
    r(this, "verifyParsing", {
      /**
       * No description
       *
       * @tags VerifyParsing
       * @name AuthV1VerifyParsingList
       * @request GET:/property-discovery-service/auth/v1/verify-parsing
       */
      authV1VerifyParsingList: (t, e = {}) => this.http.request({
        path: "/property-discovery-service/auth/v1/verify-parsing",
        method: "GET",
        query: t,
        format: "json",
        ...e
      })
    });
    r(this, "verifyParser", {
      /**
       * No description
       *
       * @tags VerifyParsing
       * @name AuthV1VerifyParserList
       * @request GET:/property-discovery-service/auth/v1/verify-parser
       */
      authV1VerifyParserList: (t, e = {}) => this.http.request({
        path: "/property-discovery-service/auth/v1/verify-parser",
        method: "GET",
        query: t,
        format: "json",
        ...e
      })
    });
    r(this, "verifyScraper", {
      /**
       * No description
       *
       * @tags VerifyScraper
       * @name AuthV1VerifyScraperCreate
       * @request POST:/property-discovery-service/auth/v1/verify-scraper/{hqId}
       */
      authV1VerifyScraperCreate: (t, e, a = {}) => this.http.request({
        path: `/property-discovery-service/auth/v1/verify-scraper/${t}`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      })
    });
    this.http = t;
  }
};
const me = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: nt,
  ContentType: y
}, Symbol.toStringTag, { value: "Module" }));
var T = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(T || {});
let ct = class {
  constructor(t) {
    r(this, "http");
    /**
     * No description
     *
     * @tags CampaignEvent
     * @name AllCompletedCreate
     * @request POST:/all-completed
     * @secure
     */
    r(this, "allCompletedCreate", (t, e = {}) => this.http.request({
      path: "/all-completed",
      method: "POST",
      body: t,
      secure: !0,
      type: "application/json",
      ...e
    }));
    r(this, "campaigns", {
      /**
       * No description
       *
       * @tags CampaignDetails
       * @name AuthV2CampaignsDetail
       * @request GET:/campaign-service/auth/v2/campaigns/{id}
       * @secure
       */
      authV2CampaignsDetail: (t, e = {}) => this.http.request({
        path: `/campaign-service/auth/v2/campaigns/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1CampaignsRetryCreate: (t, e, a = {}) => this.http.request({
        path: `/campaign-service/auth/v1/campaigns/${t}/retry`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1CampaignsCustomerRequestedStopCreate: (t, e = {}) => this.http.request({
        path: `/campaign-service/auth/v1/campaigns/${t}/customer-requested-stop`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV1CampaignsStopCreate: (t, e = {}) => this.http.request({
        path: `/campaign-service/auth/v1/campaigns/${t}/stop`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV2CampaignsReorderMetaCampaignCreate: (t, e = {}) => this.http.request({
        path: "/campaign-service/auth/v2/campaigns/reorder-meta-campaign",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1CampaignsRemoveInstagramUpdate: (t, e = {}) => this.http.request({
        path: `/campaign-service/auth/v1/campaigns/${t}/remove-instagram`,
        method: "PUT",
        secure: !0,
        ...e
      }),
      authV1CampaignsUpdateCampaignQueueCreate: (t, e, a = {}) => this.http.request({
        path: `/campaign-service/auth/v1/campaigns/${t}/update-campaign-queue`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1CampaignsDetail: (t, e, a = {}) => this.http.request({
        path: `/campaign-service/auth/v1/campaigns/${t}/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      })
    });
    r(this, "details", {});
    r(this, "campaign", {});
    r(this, "publishCampaignEvent", {});
    r(this, "readLayer", {
      /**
       * No description
       *
       * @tags CampaignOverview
       * @name AuthV1ReadLayerCampaignOverviewQueryCreate
       * @request POST:/campaign-service/auth/v1/read-layer/campaign-overview/query
       * @secure
       */
      authV1ReadLayerCampaignOverviewQueryCreate: (t, e = {}) => this.http.request({
        path: "/campaign-service/auth/v1/read-layer/campaign-overview/query",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerCampaignOverviewSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/campaign-service/auth/v1/read-layer/campaign-overview/suggestions",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "campaignStatistics", {});
    r(this, "status", {
      /**
       * No description
       *
       * @tags CampaignStatus
       * @name AuthV1StatusDetail
       * @request GET:/campaign-service/auth/v1/status/{propertyId}
       * @secure
       */
      authV1StatusDetail: (t, e = {}) => this.http.request({
        path: `/campaign-service/auth/v1/status/${t}`,
        method: "GET",
        secure: !0,
        ...e
      })
    });
    r(this, "customCampaign", {
      /**
       * No description
       *
       * @tags CustomCampaign
       * @name AuthV1CustomCampaignDetail
       * @request GET:/campaign-service/auth/v1/custom-campaign/{orderId}/{campaignTemplateId}
       * @secure
       */
      authV1CustomCampaignDetail: (t, e, a = {}) => this.http.request({
        path: `/campaign-service/auth/v1/custom-campaign/${t}/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1CustomCampaignStartCreate: (t, e = {}) => this.http.request({
        path: "/campaign-service/auth/v1/custom-campaign/start",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1CustomCampaignUpdateStatisticsCreate: (t, e = {}) => this.http.request({
        path: "/campaign-service/auth/v1/custom-campaign/update-statistics",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1CustomCampaignBatchUpdateStatisticsCreate: (t, e = {}) => this.http.request({
        path: "/campaign-service/auth/v1/custom-campaign/batch-update-statistics",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    r(this, "customAdmin", {});
    r(this, "displayAdCampaign", {
      /**
       * No description
       *
       * @tags DisplayAdCampaign
       * @name AuthV1DisplayAdCampaignMessageSettingsCreate
       * @request POST:/campaign-service/auth/v1/display-ad-campaign/{id}/message-settings
       * @secure
       */
      authV1DisplayAdCampaignMessageSettingsCreate: (t, e, a = {}) => this.http.request({
        path: `/campaign-service/auth/v1/display-ad-campaign/${t}/message-settings`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1DisplayAdCampaignMessageSettingsDetail: (t, e = {}) => this.http.request({
        path: `/campaign-service/auth/v1/display-ad-campaign/${t}/message-settings`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1DisplayAdCampaignDoNotInvoiceCreate: (t, e, a = {}) => this.http.request({
        path: `/campaign-service/auth/v1/display-ad-campaign/${t}/do-not-invoice`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1DisplayAdCampaignLandingPageSettingsCreate: (t, e, a = {}) => this.http.request({
        path: `/campaign-service/auth/v1/display-ad-campaign/${t}/landing-page-settings`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1DisplayAdCampaignLocationSettingsCreate: (t, e, a = {}) => this.http.request({
        path: `/campaign-service/auth/v1/display-ad-campaign/${t}/location-settings`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      })
    });
    r(this, "facebookAdCampaign", {
      /**
       * No description
       *
       * @tags FacebookAdCampaign
       * @name AuthV1FacebookAdCampaignMessageSettingsCreate
       * @request POST:/campaign-service/auth/v1/facebook-ad-campaign/{id}/message-settings
       * @secure
       */
      authV1FacebookAdCampaignMessageSettingsCreate: (t, e, a = {}) => this.http.request({
        path: `/campaign-service/auth/v1/facebook-ad-campaign/${t}/message-settings`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1FacebookAdCampaignMessageSettingsDetail: (t, e = {}) => this.http.request({
        path: `/campaign-service/auth/v1/facebook-ad-campaign/${t}/message-settings`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1FacebookAdCampaignLandingPageSettingsCreate: (t, e, a = {}) => this.http.request({
        path: `/campaign-service/auth/v1/facebook-ad-campaign/${t}/landing-page-settings`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1FacebookAdCampaignLocationSettingsCreate: (t, e, a = {}) => this.http.request({
        path: `/campaign-service/auth/v1/facebook-ad-campaign/${t}/location-settings`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1FacebookAdCampaignDoNotInvoiceCreate: (t, e, a = {}) => this.http.request({
        path: `/campaign-service/auth/v1/facebook-ad-campaign/${t}/do-not-invoice`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      })
    });
    r(this, "facebookAdmin", {});
    r(this, "facebookDebug", {});
    r(this, "healthCheck", {});
    r(this, "maintenance", {});
    r(this, "performance", {
      /**
       * No description
       *
       * @tags Performance
       * @name AuthV1PerformanceAreaCreate
       * @request POST:/campaign-service/auth/v1/performance/area
       * @secure
       */
      authV1PerformanceAreaCreate: (t, e = {}) => this.http.request({
        path: "/campaign-service/auth/v1/performance/area",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    r(this, "source", {});
    r(this, "result", {
      /**
       * No description
       *
       * @tags ResultsV2
       * @name AuthV2ResultDetail
       * @request GET:/campaign-service/auth/v2/result/{subjectId}
       * @secure
       */
      authV2ResultDetail: (t, e = {}) => this.http.request({
        path: `/campaign-service/auth/v2/result/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "invoicingEvent", {});
    r(this, "shortenUrl", {});
    r(this, "validateUrl", {});
    r(this, "twitterAdCampaign", {});
    r(this, "generateHistoricalDisplayAdCampaignEvents", {});
    r(this, "automaticRetry", {});
    r(this, "adIsActive", {});
    r(this, "adStopped", {});
    r(this, "adNotCreatedStillInCreationLoop", {});
    r(this, "fixBookmarks", {});
    r(this, "fixCompletedFacebookCampaignsLink", {});
    r(this, "fixFacebookCampaignsLink", {});
    r(this, "createFacebookWorkflows", {});
    r(this, "stopFacebookWorkflows", {});
    r(this, "cancelWorkflowInstances", {});
    r(this, "deleteWorkflowInstances", {});
    r(this, "fixOfficeIds", {});
    this.http = t;
  }
};
const le = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: ct,
  ContentType: T
}, Symbol.toStringTag, { value: "Module" }));
var b = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(b || {});
let mt = class {
  constructor(t) {
    r(this, "http");
    r(this, "agent", {
      /**
       * No description
       *
       * @tags Agent
       * @name AuthV1AgentDetail
       * @request GET:/agent-service/auth/v1/agent/{agentId}
       * @secure
       */
      authV1AgentDetail: (t, e = {}) => this.http.request({
        path: `/agent-service/auth/v1/agent/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1AgentUpdate: (t, e = {}) => this.http.request({
        path: "/agent-service/auth/v1/agent",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1AgentCreate: (t, e = {}) => this.http.request({
        path: "/agent-service/auth/v1/agent",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1AgentEnableAutomaticUpdatesUpdate: (t, e = {}) => this.http.request({
        path: `/agent-service/auth/v1/agent/${t}/enable-automatic-updates`,
        method: "PUT",
        secure: !0,
        ...e
      }),
      authV1AgentDeactivateCreate: (t, e = {}) => this.http.request({
        path: `/agent-service/auth/v1/agent/deactivate/${t}`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV1AgentBulkDeactivateCreate: (t, e = {}) => this.http.request({
        path: "/agent-service/auth/v1/agent/bulk-deactivate",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1AgentBulkDeactivateViaReadLayerCreate: (t, e = {}) => this.http.request({
        path: "/agent-service/auth/v1/agent/bulk-deactivate-via-read-layer",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    r(this, "publishAgentEvent", {});
    r(this, "imageTypeSettings", {
      /**
       * No description
       *
       * @tags ImageTypeSettings
       * @name AuthV1ImageTypeSettingsDetail
       * @request GET:/agent-service/auth/v1/image-type-settings/{hqId}
       * @secure
       */
      authV1ImageTypeSettingsDetail: (t, e = {}) => this.http.request({
        path: `/agent-service/auth/v1/image-type-settings/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1ImageTypeSettingsUpdate: (t, e, a = {}) => this.http.request({
        path: `/agent-service/auth/v1/image-type-settings/${t}`,
        method: "PUT",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      })
    });
    r(this, "migrate", {});
    r(this, "name", {});
    r(this, "source", {});
    this.http = t;
  }
};
const ve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: mt,
  ContentType: b
}, Symbol.toStringTag, { value: "Module" }));
var j = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(j || {});
let dt = class {
  constructor(t) {
    r(this, "http");
    r(this, "dataExport", {});
    r(this, "emailImport", {});
    this.http = t;
  }
};
const qe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: dt,
  ContentType: j
}, Symbol.toStringTag, { value: "Module" }));
var S = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(S || {});
let lt = class {
  constructor(t) {
    r(this, "http");
    r(this, "adHocOrder", {
      /**
       * No description
       *
       * @tags AdHocOrder
       * @name AuthV1AdHocOrderCreate
       * @request POST:/order-service/auth/v1/ad-hoc-order
       */
      authV1AdHocOrderCreate: (t, e = {}) => this.http.request({
        path: "/order-service/auth/v1/ad-hoc-order",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1AdHocOrderList: (t = {}) => this.http.request({
        path: "/order-service/auth/v1/ad-hoc-order",
        method: "GET",
        format: "json",
        ...t
      }),
      authV1AdHocOrderDetail: (t, e = {}) => this.http.request({
        path: `/order-service/auth/v1/ad-hoc-order/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1AdHocOrderUpdate: (t, e, a = {}) => this.http.request({
        path: `/order-service/auth/v1/ad-hoc-order/${t}/${e}`,
        method: "PUT",
        ...a
      }),
      authV1AdHocOrderStatisticsDetail: (t, e = {}) => this.http.request({
        path: `/order-service/auth/v1/ad-hoc-order/${t}/statistics`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "order", {
      /**
       * No description
       *
       * @tags Order
       * @name AuthV1OrderCancelCreate
       * @request POST:/order-service/auth/v1/order/cancel
       */
      authV1OrderCancelCreate: (t, e = {}) => this.http.request({
        path: "/order-service/auth/v1/order/cancel",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1OrderAuditLogDetail: (t, e = {}) => this.http.request({
        path: `/order-service/auth/v1/order/${t}/audit-log`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "publishOrderEvent", {});
    r(this, "programOrder", {
      /**
       * No description
       *
       * @tags ProgramOrder
       * @name AuthV2ProgramOrderCreate
       * @request POST:/order-service/auth/v2/program-order
       */
      authV2ProgramOrderCreate: (t, e = {}) => this.http.request({
        path: "/order-service/auth/v2/program-order",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ProgramOrderCancelAutoPublicationCreate: (t, e = {}) => this.http.request({
        path: `/order-service/auth/v1/program-order/cancel-auto-publication/${t}`,
        method: "POST",
        ...e
      })
    });
    r(this, "uploadCustomTargetingFile", {
      /**
       * No description
       *
       * @tags ProgramOrder
       * @name AuthV2UploadCustomTargetingFileCreate
       * @request POST:/order-service/auth/v2/upload-custom-targeting-file
       */
      authV2UploadCustomTargetingFileCreate: (t, e = {}) => this.http.request({
        path: "/order-service/auth/v2/upload-custom-targeting-file",
        method: "POST",
        body: t,
        type: "multipart/form-data",
        format: "json",
        ...e
      })
    });
    r(this, "source", {});
    r(this, "sellerOrder", {
      /**
       * No description
       *
       * @tags SellerOrder
       * @name AuthV1SellerOrderCreate
       * @request POST:/order-service/auth/v1/seller-order
       */
      authV1SellerOrderCreate: (t, e = {}) => this.http.request({
        path: "/order-service/auth/v1/seller-order",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1SellerOrderOnProgramInstanceDetail: (t, e = {}) => this.http.request({
        path: `/order-service/auth/v1/seller-order/on-program-instance/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    this.http = t;
  }
};
const Te = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: lt,
  ContentType: S
}, Symbol.toStringTag, { value: "Module" }));
var V = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(V || {});
let gt = class {
  constructor(t) {
    r(this, "http");
    r(this, "billingPeriod", {
      /**
       * No description
       *
       * @tags BillingPeriod
       * @name AuthV1BillingPeriodAddCreate
       * @request POST:/billing-service/auth/v1/billing-period/add
       */
      authV1BillingPeriodAddCreate: (t, e = {}) => this.http.request({
        path: "/billing-service/auth/v1/billing-period/add",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1BillingPeriodGetLatestCreate: (t = {}) => this.http.request({
        path: "/billing-service/auth/v1/billing-period/get-latest",
        method: "POST",
        format: "json",
        ...t
      })
    });
    r(this, "campaign", {
      /**
       * No description
       *
       * @tags Campaign
       * @name AuthV1CampaignFinancialInfoDetail
       * @request GET:/billing-service/auth/v1/campaign/financial-info/{campaignId}
       */
      authV1CampaignFinancialInfoDetail: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v1/campaign/financial-info/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "billingStatus", {});
    r(this, "forMonthWithMissingCampaigns", {});
    r(this, "campaignMigration", {});
    r(this, "billingCycle", {
      /**
       * No description
       *
       * @tags Chargify
       * @name ChargifyValidateBillingCycleCreate
       * @request POST:/v1/chargify/validate/billing-cycle
       */
      chargifyValidateBillingCycleCreate: (t, e = {}) => this.http.request({
        path: "/v1/chargify/validate/billing-cycle",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      })
    });
    r(this, "chargify", {});
    r(this, "component", {});
    r(this, "creditCardPaid", {});
    r(this, "campaignId", {
      /**
       * No description
       *
       * @tags Credited
       * @name AuthV1CreditCreate
       * @request POST:/billing-service/auth/v1/{campaignId}/credit
       */
      authV1CreditCreate: (t, e, a = {}) => this.http.request({
        path: `/billing-service/auth/v1/${t}/credit`,
        method: "POST",
        body: e,
        type: "application/json",
        ...a
      }),
      authV1RemoveCreditDelete: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v1/${t}/remove-credit`,
        method: "DELETE",
        ...e
      })
    });
    r(this, "customer", {
      /**
       * No description
       *
       * @tags Customer
       * @name AuthV1CustomerDetail
       * @request GET:/billing-service/auth/v1/customer/{customerId}
       */
      authV1CustomerDetail: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v1/customer/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "markDoNotInvoice", {});
    r(this, "removeDoNotInvoice", {});
    r(this, "publishDniEvents", {});
    r(this, "publishArchivedDniEvents", {});
    r(this, "bulkDoNotInvoice", {});
    r(this, "bulkRemoveDoNotInvoice", {});
    r(this, "migrateEmails", {});
    r(this, "invoice", {
      /**
       * No description
       *
       * @tags Invoice
       * @name AuthV1InvoiceHqDetail
       * @request GET:/billing-service/auth/v1/invoice/hq/{hqId}
       */
      authV1InvoiceHqDetail: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v1/invoice/hq/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV2InvoiceHqDetail: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v2/invoice/hq/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1InvoiceOfficeDetail: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v1/invoice/office/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV2InvoiceOfficeDetail: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v2/invoice/office/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "get", {
      /**
       * No description
       *
       * @tags Invoice
       * @name AuthV1GetInvoiceDetail
       * @request GET:/billing-service/auth/v1/get/invoice/{invoiceId}
       */
      authV1GetInvoiceDetail: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v1/get/invoice/${t}`,
        method: "GET",
        ...e
      }),
      authV1GetCreatedBreakdownReportsDetail: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v1/get/created-breakdown-reports/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1GetSentBreakdownReportsDetail: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v1/get/sent-breakdown-reports/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "create", {
      /**
       * No description
       *
       * @tags Invoice
       * @name AuthV1CreateInvoicesDetailReportsCreate
       * @request POST:/billing-service/auth/v1/create/invoices-detail-reports
       */
      authV1CreateInvoicesDetailReportsCreate: (t, e = {}) => this.http.request({
        path: "/billing-service/auth/v1/create/invoices-detail-reports",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      })
    });
    r(this, "send", {
      /**
       * No description
       *
       * @tags Invoice
       * @name AuthV1SendInvoicesDetailReportsCreate
       * @request POST:/billing-service/auth/v1/send/invoices-detail-reports
       */
      authV1SendInvoicesDetailReportsCreate: (t, e = {}) => this.http.request({
        path: "/billing-service/auth/v1/send/invoices-detail-reports",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      })
    });
    r(this, "bulkRemoveDni", {});
    r(this, "payment", {
      /**
       * No description
       *
       * @tags Payment
       * @name AuthV1PaymentGetPaymentsDetail
       * @request GET:/billing-service/auth/v1/payment/get-payments/{orderId}
       */
      authV1PaymentGetPaymentsDetail: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v1/payment/get-payments/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1PaymentSetContractSignedCreate: (t, e = {}) => this.http.request({
        path: "/billing-service/auth/v1/payment/set-contract-signed",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1PaymentSetContractSignedUpdate: (t, e, a = {}) => this.http.request({
        path: `/billing-service/auth/v1/payment/${t}/set-contract-signed/${e}`,
        method: "PUT",
        ...a
      }),
      authV2PaymentSetContractSignedCreate: (t, e = {}) => this.http.request({
        path: "/billing-service/auth/v2/payment/set-contract-signed",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1PaymentSetSellerOrderPaidCreate: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v1/payment/set-seller-order-paid/${t}`,
        method: "POST",
        ...e
      }),
      authV1PaymentRetryCreditCardChargeCreate: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v1/payment/retry-credit-card-charge/${t}`,
        method: "POST",
        ...e
      })
    });
    r(this, "source", {});
    r(this, "report", {
      /**
       * No description
       *
       * @tags Report
       * @name AuthV1ReportZeroSpendDetail
       * @request GET:/billing-service/auth/v1/report/zero-spend/{year}/{month}
       */
      authV1ReportZeroSpendDetail: (t, e, a = {}) => this.http.request({
        path: `/billing-service/auth/v1/report/zero-spend/${t}/${e}`,
        method: "GET",
        ...a
      }),
      authV1ReportBillingDetail: (t, e = {}) => this.http.request({
        path: `/billing-service/auth/v1/report/billing/${t}`,
        method: "GET",
        ...e
      }),
      authV1ReportCreditedCampaignsDetail: (t, e, a = {}) => this.http.request({
        path: `/billing-service/auth/v1/report/credited-campaigns/${t}/${e}`,
        method: "GET",
        ...a
      }),
      authV1ReportDniedCampaignsDetail: (t, e, a = {}) => this.http.request({
        path: `/billing-service/auth/v1/report/dnied-campaigns/${t}/${e}`,
        method: "GET",
        ...a
      })
    });
    r(this, "subscription", {
      /**
       * No description
       *
       * @tags Subscription
       * @name AuthV1SubscriptionCancelSubscriptionDetail
       * @request GET:/billing-service/auth/v1/subscription/{customerId}/cancel-subscription
       */
      authV1SubscriptionCancelSubscriptionDetail: (t, e, a = {}) => this.http.request({
        path: `/billing-service/auth/v1/subscription/${t}/cancel-subscription`,
        method: "GET",
        query: e,
        format: "json",
        ...a
      }),
      authV1SubscriptionGetOrCreateSubscriptionCreate: (t, e = {}) => this.http.request({
        path: "/billing-service/auth/v1/subscription/get-or-create-subscription",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "test", {});
    this.http = t;
  }
};
const je = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: gt,
  ContentType: V
}, Symbol.toStringTag, { value: "Module" }));
var $ = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))($ || {});
let vt = class {
  constructor(t) {
    r(this, "http");
    /**
     * No description
     *
     * @tags Currency
     * @name InternalV1Create
     * @request POST:/currency-conversion/internal/v1
     */
    r(this, "internalV1Create", (t, e = {}) => this.http.request({
      path: "/currency-conversion/internal/v1",
      method: "POST",
      body: t,
      type: "application/json",
      ...e
    }));
    r(this, "currency", {});
    this.http = t;
  }
};
const Ve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: vt,
  ContentType: $
}, Symbol.toStringTag, { value: "Module" }));
var P = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(P || {});
let ft = class {
  constructor(t) {
    r(this, "http");
    r(this, "hqs", {
      /**
       * No description
       *
       * @tags Agent
       * @name AuthV1HqsAgentsTriggerCreate
       * @summary Emit a trigger for the specified Agent.
       * @request POST:/external-api/auth/v1/hqs/{hqId}/agents/{agentId}/trigger/{triggerId}
       * @secure
       */
      authV1HqsAgentsTriggerCreate: (t, e, a, s = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/agents/${e}/trigger/${a}`,
        method: "POST",
        secure: !0,
        ...s
      }),
      authV1HqsAgentsTriggerCreate2: (t, e, a, s, o = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/agents/${e}/trigger/${a}/${s}`,
        method: "POST",
        secure: !0,
        ...o
      }),
      authV1HqsAgentsDetail: (t, e, a = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/agents`,
        method: "GET",
        query: e,
        secure: !0,
        format: "json",
        ...a
      }),
      authV1HqsAgentsCreate: (t, e, a = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/agents`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        format: "json",
        ...a
      }),
      authV1HqsCampaignsFacebookDetail: (t, e, a = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/campaigns/facebook`,
        method: "GET",
        query: e,
        secure: !0,
        format: "json",
        ...a
      }),
      authV1HqsCampaignsDisplayDetail: (t, e, a = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/campaigns/display`,
        method: "GET",
        query: e,
        secure: !0,
        format: "json",
        ...a
      }),
      authV1HqsList: (t, e = {}) => this.http.request({
        path: "/external-api/auth/v1/hqs",
        method: "GET",
        query: t,
        secure: !0,
        format: "json",
        ...e
      }),
      authV1HqsDetail: (t, e = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1HqsOfficesDetail: (t, e, a = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/offices`,
        method: "GET",
        query: e,
        secure: !0,
        format: "json",
        ...a
      }),
      authV1HqsOfficesCreate: (t, e, a = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/offices`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        format: "json",
        ...a
      }),
      authV1HqsOfficesTriggerCreate: (t, e, a, s = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/offices/${e}/trigger/${a}`,
        method: "POST",
        secure: !0,
        ...s
      }),
      authV1HqsOfficesTriggerCreate2: (t, e, a, s, o = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/offices/${e}/trigger/${a}/${s}`,
        method: "POST",
        secure: !0,
        ...o
      }),
      authV1HqsPropertiesDetail: (t, e, a = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/properties/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1HqsPropertiesUpdate: (t, e, a, s = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/properties/${e}`,
        method: "PUT",
        body: a,
        secure: !0,
        type: "application/json",
        format: "json",
        ...s
      }),
      authV1HqsPropertiesCreate: (t, e, a = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/properties`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        format: "json",
        ...a
      }),
      authV1HqsPropertiesDetail2: (t, e, a = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/properties`,
        method: "GET",
        query: e,
        secure: !0,
        format: "json",
        ...a
      }),
      authV1HqsPropertiesByInternalCodeDetail: (t, e, a = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/properties/by-internal-code/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1HqsPropertiesByExternalIdentifierDetail: (t, e, a = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/properties/by-external-identifier/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1HqsPropertiesByDataContextPropertyIdDetail: (t, e, a = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/properties/by-data-context-property-id/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1HqsOfficePropertiesDetail: (t, e, a, s = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/office/${e}/properties`,
        method: "GET",
        query: a,
        secure: !0,
        format: "json",
        ...s
      }),
      authV1HqsPropertiesInviteSellerCreate: (t, e, a, s = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/properties/${e}/invite-seller`,
        method: "POST",
        query: a,
        secure: !0,
        format: "json",
        ...s
      }),
      authV1HqsPropertiesTriggerCreate: (t, e, a, s = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/properties/${e}/trigger/${a}`,
        method: "POST",
        secure: !0,
        ...s
      }),
      authV1HqsPropertiesTriggerCreate2: (t, e, a, s, o = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/properties/${e}/trigger/${a}/${s}`,
        method: "POST",
        secure: !0,
        ...o
      }),
      authV1HqsPropertiesTriggerCreate3: (t, e, a, s, o = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/properties/${e}/${a}/trigger/${s}`,
        method: "POST",
        secure: !0,
        ...o
      }),
      authV1HqsPropertiesTriggerCreate4: (t, e, a, s, o, N = {}) => this.http.request({
        path: `/external-api/auth/v1/hqs/${t}/properties/${e}/${a}/trigger/${s}/${o}`,
        method: "POST",
        secure: !0,
        ...N
      })
    });
    r(this, "login", {
      /**
       * No description
       *
       * @tags Auth
       * @name PublicV1LoginCreate
       * @summary Get API token for a user using email and password.
       * @request POST:/external-api/public/v1/login
       */
      publicV1LoginCreate: (t, e = {}) => this.http.request({
        path: "/external-api/public/v1/login",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "refreshToken", {
      /**
       * No description
       *
       * @tags Auth
       * @name PublicV1RefreshTokenCreate
       * @summary Refresh API token
       * @request POST:/external-api/public/v1/refresh-token
       */
      publicV1RefreshTokenCreate: (t, e = {}) => this.http.request({
        path: "/external-api/public/v1/refresh-token",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "property", {
      /**
       * No description
       *
       * @tags Property
       * @name AuthV1PropertyByUrlDetail
       * @summary Search for the provided listing page URL and returns an URL to the property details page if it exists and the current
      user has access to the attached HQ.
       * @request GET:/external-api/auth/v1/property/by-url/{url}
       * @secure
       */
      authV1PropertyByUrlDetail: (t, e = {}) => this.http.request({
        path: `/external-api/auth/v1/property/by-url/${t}`,
        method: "GET",
        secure: !0,
        ...e
      })
    });
    this.http = t;
  }
};
const Pe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: ft,
  ContentType: P
}, Symbol.toStringTag, { value: "Module" }));
var O = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(O || {});
let qt = class {
  constructor(t) {
    r(this, "http");
    r(this, "cron", {
      /**
       * No description
       *
       * @tags CronDescription
       * @name AuthV1CronDetail
       * @request GET:/scheduler-service/auth/v1/cron/{cron}
       */
      authV1CronDetail: (t, e = {}) => this.http.request({
        path: `/scheduler-service/auth/v1/cron/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "job", {
      /**
       * No description
       *
       * @tags Job
       * @name AuthV1JobHttpCreate
       * @request POST:/scheduler-service/auth/v1/job/http
       */
      authV1JobHttpCreate: (t, e = {}) => this.http.request({
        path: "/scheduler-service/auth/v1/job/http",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1JobRabbitmqCreate: (t, e = {}) => this.http.request({
        path: "/scheduler-service/auth/v1/job/rabbitmq",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1JobDelete: (t, e = {}) => this.http.request({
        path: `/scheduler-service/auth/v1/job/${t}`,
        method: "DELETE",
        ...e
      }),
      authV1JobListList: (t = {}) => this.http.request({
        path: "/scheduler-service/auth/v1/job/list",
        method: "GET",
        format: "json",
        ...t
      })
    });
    this.http = t;
  }
};
const Ee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: qt,
  ContentType: O
}, Symbol.toStringTag, { value: "Module" }));
var E = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(E || {});
let yt = class {
  constructor(t) {
    r(this, "http");
    r(this, "seller", {
      /**
       * No description
       *
       * @tags Seller
       * @name AuthV1SellerCreate
       * @request POST:/seller-service/auth/v1/seller
       */
      authV1SellerCreate: (t, e = {}) => this.http.request({
        path: "/seller-service/auth/v1/seller",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1SellerExistsOnPropertyDetail: (t, e = {}) => this.http.request({
        path: `/seller-service/auth/v1/seller/exists-on-property/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "inviteSeller", {
      /**
       * No description
       *
       * @tags Seller
       * @name AuthV1InviteSellerCreate
       * @request POST:/seller-service/auth/v1/invite-seller
       */
      authV1InviteSellerCreate: (t, e = {}) => this.http.request({
        path: "/seller-service/auth/v1/invite-seller",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      })
    });
    this.http = t;
  }
};
const De = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: yt,
  ContentType: E
}, Symbol.toStringTag, { value: "Module" }));
var C = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(C || {});
let Tt = class {
  constructor(t) {
    r(this, "http");
    r(this, "officeId", {
      /**
       * No description
       *
       * @tags Tax
       * @name V1TaxDetail
       * @request GET:/api/v1/tax/{officeId}/{productId}
       */
      v1TaxDetail: (t, e, a = {}) => this.http.request({
        path: `/api/v1/tax/${t}/${e}`,
        method: "GET",
        format: "json",
        ...a
      }),
      v1TaxDetail2: (t, e = {}) => this.http.request({
        path: `/api/v1/tax/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "country", {
      /**
       * No description
       *
       * @tags Tax
       * @name V1TaxCountryPostalcodeDetail
       * @request GET:/api/v1/tax/country/{country}/postalcode/{postalCode}
       */
      v1TaxCountryPostalcodeDetail: (t, e, a = {}) => this.http.request({
        path: `/api/v1/tax/country/${t}/postalcode/${e}`,
        method: "GET",
        format: "json",
        ...a
      })
    });
    this.http = t;
  }
};
const Ae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Tt,
  ContentType: C
}, Symbol.toStringTag, { value: "Module" }));
var D = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(D || {});
let bt = class {
  constructor(t) {
    r(this, "http");
    r(this, "location", {});
    this.http = t;
  }
};
const He = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: bt,
  ContentType: D
}, Symbol.toStringTag, { value: "Module" }));
var U = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(U || {});
let jt = class {
  constructor(t) {
    r(this, "http");
    /**
     * No description
     *
     * @tags GetScripts
     * @name GetscriptsCreate
     * @request POST:/adfenix/getscripts
     * @secure
     */
    r(this, "getscriptsCreate", (t, e = {}) => this.http.request({
      path: "/adfenix/getscripts",
      method: "POST",
      body: t,
      secure: !0,
      type: "application/json",
      ...e
    }));
    r(this, "scripts", {
      /**
       * No description
       *
       * @tags GetScripts
       * @name PublicV1ScriptsCreate
       * @request POST:/get-scripts-service/public/v1/scripts
       * @secure
       */
      publicV1ScriptsCreate: (t, e = {}) => this.http.request({
        path: "/get-scripts-service/public/v1/scripts",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1ScriptsHqDetail: (t, e = {}) => this.http.request({
        path: `/get-scripts-service/auth/v1/scripts/hq/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1ScriptsCreate: (t, e = {}) => this.http.request({
        path: "/get-scripts-service/auth/v1/scripts",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1ScriptsUpdate: (t, e = {}) => this.http.request({
        path: "/get-scripts-service/auth/v1/scripts",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1ScriptsDelete: (t, e = {}) => this.http.request({
        path: `/get-scripts-service/auth/v1/scripts/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      })
    });
    r(this, "hq", {
      /**
       * No description
       *
       * @tags Hq
       * @name AuthV1HqLanguageCreate
       * @request POST:/get-scripts-service/auth/v1/hq/{hqId}/language
       * @secure
       */
      authV1HqLanguageCreate: (t, e, a = {}) => this.http.request({
        path: `/get-scripts-service/auth/v1/hq/${t}/language`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1HqDisplayadActiveCreate: (t, e, a = {}) => this.http.request({
        path: `/get-scripts-service/auth/v1/hq/${t}/displayad-active`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      })
    });
    r(this, "property", {
      /**
       * No description
       *
       * @tags Property
       * @name AuthV1PropertyDetail
       * @request GET:/get-scripts-service/auth/v1/property/{propertyId}
       * @secure
       */
      authV1PropertyDetail: (t, e = {}) => this.http.request({
        path: `/get-scripts-service/auth/v1/property/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1PropertyLockPageCreate: (t, e = {}) => this.http.request({
        path: "/get-scripts-service/auth/v1/property/lock-page",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    this.http = t;
  }
};
const Le = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: jt,
  ContentType: U
}, Symbol.toStringTag, { value: "Module" }));
var A = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(A || {});
let St = class {
  constructor(t) {
    r(this, "http");
    r(this, "readLayer", {
      /**
       * No description
       *
       * @tags AgentSearch
       * @name AuthV1ReadLayerAgentDetail
       * @request GET:/read-layer/auth/v1/read-layer/agent/{id}
       */
      authV1ReadLayerAgentDetail: (t, e = {}) => this.http.request({
        path: `/read-layer/auth/v1/read-layer/agent/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1ReadLayerAgentQueryCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/agent/query",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerAgentSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/agent/suggestions",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerAuditLogQueryCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/audit-log/query",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerAuditLogSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/audit-log/suggestions",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerCustomerCampaignOverviewQueryCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/customer-campaign-overview/query",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerCustomerCampaignOverviewSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/customer-campaign-overview/suggestions",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerCustomerCampaignOverviewStatsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/customer-campaign-overview/stats",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerCampaignOverviewQueryCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/campaign-overview/query",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerCampaignOverviewSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/campaign-overview/suggestions",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerCampaignOverviewStatsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/campaign-overview/stats",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerOfficeDetail: (t, e = {}) => this.http.request({
        path: `/read-layer/auth/v1/read-layer/office/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1ReadLayerOfficeQueryCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/office/query",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerOfficeSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/office/suggestions",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerOrderGetDetail: (t, e = {}) => this.http.request({
        path: `/read-layer/auth/v1/read-layer/order/get/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1ReadLayerOrderQueryCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/order/query",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerOrderSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/order/suggestions",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerOrderStatsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/order/stats",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerOrderedBundleQueryCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/ordered-bundle/query",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerOrderedBundleSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/ordered-bundle/suggestions",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerOrderedBundleStatsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/ordered-bundle/stats",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerPaymentQueryCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/payment/query",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerPaymentSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/payment/suggestions",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerPaymentStatsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/payment/stats",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerProgramInstanceQueryCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/program-instance/query",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerProgramInstanceSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/program-instance/suggestions",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerProgramInstanceStatsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/program-instance/stats",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerProgramReportCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/program-report",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerProgramReportConversionsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/program-report/conversions",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerProgramReportOpportunitiesCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/program-report/opportunities",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerProgramReportCampaignsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/program-report/campaigns",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerProgramQueryCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/program/query",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerProgramSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/read-layer/auth/v1/read-layer/program/suggestions",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "get", {});
    r(this, "getList", {});
    r(this, "search", {});
    r(this, "getIds", {});
    r(this, "searchAfter", {});
    r(this, "suggestions", {});
    r(this, "indexId", {});
    r(this, "reCreateAndIndexAll", {});
    r(this, "reIndex", {});
    r(this, "indexDocuments", {});
    r(this, "hq", {});
    r(this, "office", {});
    r(this, "agent", {});
    r(this, "user", {});
    r(this, "source", {});
    r(this, "untyped", {});
    r(this, "update", {});
    this.http = t;
  }
};
const xe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: St,
  ContentType: A
}, Symbol.toStringTag, { value: "Module" }));
var G = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(G || {});
let Vt = class {
  constructor(t) {
    r(this, "http");
    r(this, "batch", {
      /**
       * No description
       *
       * @tags BatchActions
       * @name AuthV1BatchUpdateBudgetUpdate
       * @request PUT:/program-service/auth/v1/batch/update-budget
       * @secure
       */
      authV1BatchUpdateBudgetUpdate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/batch/update-budget",
        method: "PUT",
        body: t,
        secure: !0,
        type: "multipart/form-data",
        format: "json",
        ...e
      })
    });
    r(this, "readLayer", {
      /**
       * No description
       *
       * @tags BundleAuth
       * @name AuthV1ReadLayerBundleQueryCreate
       * @request POST:/program-service/auth/v1/read-layer/bundle/query
       * @secure
       */
      authV1ReadLayerBundleQueryCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/read-layer/bundle/query",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerBundleSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/read-layer/bundle/suggestions",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerProgramQueryCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/read-layer/program/query",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerProgramSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/read-layer/program/suggestions",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerPrograminstanceQueryCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/read-layer/programinstance/query",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ReadLayerPrograminstanceSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/read-layer/programinstance/suggestions",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "campaignTemplate", {});
    r(this, "triggers", {
      /**
       * No description
       *
       * @tags CustomTriggers
       * @name AuthV1TriggersCreate
       * @request POST:/program-service/auth/v1/triggers/{hqId}
       * @secure
       */
      authV1TriggersCreate: (t, e, a, s = {}) => this.http.request({
        path: `/program-service/auth/v1/triggers/${t}`,
        method: "POST",
        query: a,
        body: e,
        secure: !0,
        type: "application/json",
        ...s
      }),
      authV1TriggersDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/triggers/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1TriggersCreate2: (t, e, a, s = {}) => this.http.request({
        path: `/program-service/auth/v1/triggers/${t}/${e}`,
        method: "POST",
        body: a,
        secure: !0,
        type: "application/json",
        ...s
      })
    });
    r(this, "dev", {});
    r(this, "event", {});
    r(this, "healthCheck", {});
    r(this, "program", {
      /**
       * No description
       *
       * @tags ProgramAuth
       * @name AuthV1ProgramSearchCreate
       * @request POST:/program-service/auth/v1/program/search
       * @secure
       */
      authV1ProgramSearchCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program/search",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ProgramSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program/suggestions",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ProgramDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1ProgramCreateCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program/create",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ProgramUpdate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program",
        method: "PUT",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1ProgramDuplicateCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program/duplicate",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ProgramGetProgramsToTriggerCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program/get-programs-to-trigger",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1ProgramGetCanTriggerProgramsCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program/get-can-trigger-programs",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV2ProgramAvailableTriggerEventsDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v2/program/available-trigger-events/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1ProgramAvailableTriggerEventsList: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program/available-trigger-events",
        method: "GET",
        query: t,
        secure: !0,
        ...e
      }),
      authV1ProgramDelete: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      }),
      authV1ProgramActivateUpdate: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program/${t}/activate`,
        method: "PUT",
        secure: !0,
        ...e
      }),
      authV1ProgramRequestActivationCreate: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program/${t}/request-activation`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV1ProgramDeactivateUpdate: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program/${t}/deactivate`,
        method: "PUT",
        secure: !0,
        ...e
      }),
      authV1ProgramAvailableAttributesDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program/${t}/available-attributes`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1ProgramBundleAvailableCampaignTemplatesDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program/bundle/${t}/available-campaign-templates`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1ProgramTriggerForPropertiesCreate: (t, e, a, s = {}) => this.http.request({
        path: `/program-service/auth/v1/program/${t}/trigger-for-properties/${e}`,
        method: "POST",
        body: a,
        secure: !0,
        type: "application/json",
        format: "json",
        ...s
      }),
      authV1ProgramTriggerForAgentsCreate: (t, e, a, s = {}) => this.http.request({
        path: `/program-service/auth/v1/program/${t}/trigger-for-agents/${e}`,
        method: "POST",
        body: a,
        secure: !0,
        type: "application/json",
        format: "json",
        ...s
      }),
      authV1ProgramTriggerForOfficesCreate: (t, e, a, s = {}) => this.http.request({
        path: `/program-service/auth/v1/program/${t}/trigger-for-offices/${e}`,
        method: "POST",
        body: a,
        secure: !0,
        type: "application/json",
        format: "json",
        ...s
      }),
      authV1ProgramAuditLogDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program/${t}/audit-log`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1ProgramPropertiesNonAdminsCanEditList: (t = {}) => this.http.request({
        path: "/program-service/auth/v1/program/properties-non-admins-can-edit",
        method: "GET",
        secure: !0,
        format: "json",
        ...t
      })
    });
    r(this, "inviteSeller", {
      /**
       * No description
       *
       * @tags InviteSeller
       * @name AuthV1InviteSellerCreate
       * @request POST:/program-service/auth/v1/invite-seller/{hqId}/{propertyId}
       * @secure
       */
      authV1InviteSellerCreate: (t, e, a = {}) => this.http.request({
        path: `/program-service/auth/v1/invite-seller/${t}/${e}`,
        method: "POST",
        secure: !0,
        ...a
      })
    });
    r(this, "migration", {});
    r(this, "orderPage", {
      /**
       * No description
       *
       * @tags OrderPage
       * @name AuthV1OrderPageAvailableOnSubjectDetail
       * @request GET:/program-service/auth/v1/order-page/available-on-subject/{subjectType}/{subjectId}
       * @secure
       */
      authV1OrderPageAvailableOnSubjectDetail: (t, e, a = {}) => this.http.request({
        path: `/program-service/auth/v1/order-page/available-on-subject/${t}/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1OrderPageCustomerOnProgramInstanceDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/order-page/customer/on-program-instance/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1OrderPageCustomerOnProgramInstanceFormattedContentDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/order-page/customer/on-program-instance/${t}/formatted-content`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1OrderPageTestFormattedContentDetail: (t, e, a = {}) => this.http.request({
        path: `/program-service/auth/v1/order-page/test/${t}/${e}/formatted-content`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1OrderPageTestDetail: (t, e, a = {}) => this.http.request({
        path: `/program-service/auth/v1/order-page/test/${t}/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1OrderPageSubscriptionBundlesDetail: (t, e, a = {}) => this.http.request({
        path: `/program-service/auth/v1/order-page/subscription-bundles/${t}/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1OrderPageSellerOnProgramInstanceDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/order-page/seller/on-program-instance/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "programInstance", {
      /**
       * No description
       *
       * @tags OrderPage
       * @name AuthV1ProgramInstanceHqInfoDetail
       * @request GET:/program-service/auth/v1/program-instance/{id}/hq-info
       * @secure
       */
      authV1ProgramInstanceHqInfoDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program-instance/${t}/hq-info`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2ProgramInstanceCustomerOrderPageDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v2/program-instance/${t}/customer-order-page`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2ProgramInstanceTestOrderPageDetail: (t, e, a = {}) => this.http.request({
        path: `/program-service/auth/v2/program-instance/test-order-page/${t}/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV3ProgramInstanceTestOrderPageDetail: (t, e, a, s, o = {}) => this.http.request({
        path: `/program-service/auth/v3/program-instance/test-order-page/${t}/${e}/${s}/${a}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...o
      }),
      authV3ProgramInstanceTestOrderPageFormattedContentDetail: (t, e, a, s, o = {}) => this.http.request({
        path: `/program-service/auth/v3/program-instance/test-order-page/${t}/${e}/${s}/${a}/formatted-content`,
        method: "GET",
        secure: !0,
        format: "json",
        ...o
      }),
      authV1ProgramInstanceResendStartSellersChoiceCreate: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program-instance/resend-start-sellers-choice/${t}`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV1ProgramInstanceSearchCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program-instance/search",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ProgramInstanceSuggestionsCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program-instance/suggestions",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ProgramInstanceDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program-instance/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV2ProgramInstanceDetail: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v2/program-instance/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1ProgramInstanceAvailableProgramsDetail: (t, e, a = {}) => this.http.request({
        path: `/program-service/auth/v1/program-instance/available-programs/${t}/${e}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1ProgramInstanceRecheckConditionsCreate: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program-instance/recheck-conditions/${t}`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV1ProgramInstanceRetryOfficeActiveCreate: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program-instance/retry-office-active/${t}`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV1ProgramInstanceRetryBlockedWorkflowCreate: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program-instance/retry-blocked-workflow/${t}`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV1ProgramInstanceSendManualPublicationOfferCreate: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program-instance/send-manual-publication-offer/${t}`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV1ProgramInstanceTryCreateCreate: (t, e, a = {}) => this.http.request({
        path: `/program-service/auth/v1/program-instance/try-create/${t}/${e}`,
        method: "POST",
        secure: !0,
        format: "json",
        ...a
      }),
      authV1ProgramInstanceCancelAutoPublishCreate: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program-instance/cancel-auto-publish/${t}`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV1ProgramInstanceStopCreate: (t, e = {}) => this.http.request({
        path: `/program-service/auth/v1/program-instance/stop/${t}`,
        method: "POST",
        secure: !0,
        ...e
      }),
      authV1ProgramInstanceBulkStopCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program-instance/bulk-stop",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ProgramInstanceBulkCancelAutopublishCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program-instance/bulk-cancel-autopublish",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1ProgramInstanceBulkRecheckCondtionsCreate: (t, e = {}) => this.http.request({
        path: "/program-service/auth/v1/program-instance/bulk-recheck-condtions",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      publicV1ProgramInstanceSubjectIdDetail: (t, e = {}) => this.http.request({
        path: `/program-service/public/v1/program-instance/${t}/subject-id`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "programAdmin", {});
    r(this, "programInstanceAdmin", {});
    r(this, "name", {});
    r(this, "source", {});
    r(this, "workflowTest", {});
    this.http = t;
  }
};
const _e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Vt,
  ContentType: G
}, Symbol.toStringTag, { value: "Module" }));
var H = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(H || {});
let $t = class {
  constructor(t) {
    r(this, "http");
    r(this, "agent", {
      /**
       * No description
       *
       * @tags Agent
       * @name AuthV1AgentCreate
       * @request POST:/quedro-integration-service/auth/v1/agent
       * @secure
       */
      authV1AgentCreate: (t, e = {}) => this.http.request({
        path: "/quedro-integration-service/auth/v1/agent",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    r(this, "contact", {
      /**
       * No description
       *
       * @tags Contact
       * @name AuthV1ContactUpdateDetail
       * @request GET:/quedro-integration-service/auth/v1/contact/{hqId}/update
       * @secure
       */
      authV1ContactUpdateDetail: (t, e = {}) => this.http.request({
        path: `/quedro-integration-service/auth/v1/contact/${t}/update`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1ContactAgentUpdateDetail: (t, e, a = {}) => this.http.request({
        path: `/quedro-integration-service/auth/v1/contact/${t}/agent/${e}/update`,
        method: "GET",
        secure: !0,
        ...a
      })
    });
    r(this, "crmEvent", {
      /**
       * No description
       *
       * @tags CrmEvent
       * @name AuthV1CrmEventCreate
       * @request POST:/quedro-integration-service/auth/v1/crm-event
       * @secure
       */
      authV1CrmEventCreate: (t, e = {}) => this.http.request({
        path: "/quedro-integration-service/auth/v1/crm-event",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    r(this, "rawEvent", {
      /**
       * No description
       *
       * @tags CrmEvent
       * @name AuthV1RawEventCreate
       * @request POST:/quedro-integration-service/auth/v1/raw-event
       * @secure
       */
      authV1RawEventCreate: (t = {}) => this.http.request({
        path: "/quedro-integration-service/auth/v1/raw-event",
        method: "POST",
        secure: !0,
        ...t
      })
    });
    r(this, "hqConfiguration", {
      /**
       * No description
       *
       * @tags HqConfiguration
       * @name AuthV1HqConfigurationDetail
       * @request GET:/quedro-integration-service/auth/v1/hq-configuration/{hqId}
       * @secure
       */
      authV1HqConfigurationDetail: (t, e = {}) => this.http.request({
        path: `/quedro-integration-service/auth/v1/hq-configuration/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1HqConfigurationCreate: (t, e = {}) => this.http.request({
        path: "/quedro-integration-service/auth/v1/hq-configuration",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    r(this, "integration", {});
    r(this, "hqResolverSettings", {
      /**
       * No description
       *
       * @tags HqResolverSettings
       * @name AuthV1HqResolverSettingsDetail
       * @request GET:/quedro-integration-service/auth/v1/hq-resolver-settings/{hqId}
       * @secure
       */
      authV1HqResolverSettingsDetail: (t, e = {}) => this.http.request({
        path: `/quedro-integration-service/auth/v1/hq-resolver-settings/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1HqResolverSettingsDelete: (t, e = {}) => this.http.request({
        path: `/quedro-integration-service/auth/v1/hq-resolver-settings/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      }),
      authV1HqResolverSettingsCreate: (t, e = {}) => this.http.request({
        path: "/quedro-integration-service/auth/v1/hq-resolver-settings",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      })
    });
    r(this, "limitedHqConfiguration", {
      /**
       * No description
       *
       * @tags LimitedHqConfiguration
       * @name AuthV1LimitedHqConfigurationDetail
       * @request GET:/quedro-integration-service/auth/v1/limited-hq-configuration/{hqId}
       * @secure
       */
      authV1LimitedHqConfigurationDetail: (t, e = {}) => this.http.request({
        path: `/quedro-integration-service/auth/v1/limited-hq-configuration/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "property", {
      /**
       * No description
       *
       * @tags Property
       * @name AuthV1PropertyCreate
       * @request POST:/quedro-integration-service/auth/v1/property
       * @secure
       */
      authV1PropertyCreate: (t, e = {}) => this.http.request({
        path: "/quedro-integration-service/auth/v1/property",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1PropertyGetQuedroPropertyIdCreate: (t, e = {}) => this.http.request({
        path: "/quedro-integration-service/auth/v1/property/get-quedro-property-id",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      }),
      authV1PropertyQuedroPropertyCreate: (t, e = {}) => this.http.request({
        path: "/quedro-integration-service/auth/v1/property/quedro-property",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1PropertySyncCreate: (t, e = {}) => this.http.request({
        path: "/quedro-integration-service/auth/v1/property/sync",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1PropertyTestCreate: (t, e = {}) => this.http.request({
        path: "/quedro-integration-service/auth/v1/property/test",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    r(this, "source", {});
    r(this, "sellerPaidTest", {});
    this.http = t;
  }
};
const Fe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: $t,
  ContentType: H
}, Symbol.toStringTag, { value: "Module" }));
var k = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(k || {});
let Pt = class {
  constructor(t) {
    r(this, "http");
    r(this, "hq", {
      /**
       * No description
       *
       * @tags HqSettings
       * @name AuthV1HqSettingsDetail
       * @request GET:/property-event-service/auth/v1/hq/{hqId}/settings
       */
      authV1HqSettingsDetail: (t, e = {}) => this.http.request({
        path: `/property-event-service/auth/v1/hq/${t}/settings`,
        method: "GET",
        ...e
      }),
      authV1HqSettingsUpdate: (t, e, a = {}) => this.http.request({
        path: `/property-event-service/auth/v1/hq/${t}/settings`,
        method: "PUT",
        body: e,
        type: "application/json",
        ...a
      })
    });
    this.http = t;
  }
};
const Be = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Pt,
  ContentType: k
}, Symbol.toStringTag, { value: "Module" }));
var L = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(L || {});
let Ot = class {
  constructor(t) {
    r(this, "http");
    r(this, "monitoring", {
      /**
       * No description
       *
       * @tags Monitoring
       * @name AuthV1MonitoringCreate
       * @request POST:/monitoring-service/auth/v1/monitoring
       */
      authV1MonitoringCreate: (t, e = {}) => this.http.request({
        path: "/monitoring-service/auth/v1/monitoring",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1MonitoringList: (t = {}) => this.http.request({
        path: "/monitoring-service/auth/v1/monitoring",
        method: "GET",
        format: "json",
        ...t
      }),
      authV2MonitoringCreate: (t, e = {}) => this.http.request({
        path: "/monitoring-service/auth/v2/monitoring",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1MonitoringLockCreate: (t, e = {}) => this.http.request({
        path: `/monitoring-service/auth/v1/monitoring/${t}/lock`,
        method: "POST",
        ...e
      }),
      authV1MonitoringUnLockCreate: (t, e = {}) => this.http.request({
        path: `/monitoring-service/auth/v1/monitoring/${t}/un-lock`,
        method: "POST",
        ...e
      })
    });
    r(this, "programMonitoring", {
      /**
       * No description
       *
       * @tags Monitoring
       * @name AuthV1ProgramMonitoringDetail
       * @request GET:/monitoring-service/auth/v1/program-monitoring/{id}
       */
      authV1ProgramMonitoringDetail: (t, e = {}) => this.http.request({
        path: `/monitoring-service/auth/v1/program-monitoring/${t}`,
        method: "GET",
        format: "json",
        ...e
      }),
      authV1ProgramMonitoringCreate: (t, e = {}) => this.http.request({
        path: "/monitoring-service/auth/v1/program-monitoring",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      })
    });
    r(this, "officeHasRecentCampaign", {
      /**
       * No description
       *
       * @tags Monitoring
       * @name AuthV1OfficeHasRecentCampaignCreate
       * @request POST:/monitoring-service/auth/v1/office-has-recent-campaign/{officeId}
       */
      authV1OfficeHasRecentCampaignCreate: (t, e = {}) => this.http.request({
        path: `/monitoring-service/auth/v1/office-has-recent-campaign/${t}`,
        method: "POST",
        ...e
      })
    });
    r(this, "agentHasRecentCampaign", {
      /**
       * No description
       *
       * @tags Monitoring
       * @name AuthV1AgentHasRecentCampaignCreate
       * @request POST:/monitoring-service/auth/v1/agent-has-recent-campaign/{agentId}
       */
      authV1AgentHasRecentCampaignCreate: (t, e = {}) => this.http.request({
        path: `/monitoring-service/auth/v1/agent-has-recent-campaign/${t}`,
        method: "POST",
        ...e
      })
    });
    r(this, "propertyHasRecentCampaign", {
      /**
       * No description
       *
       * @tags Monitoring
       * @name AuthV1PropertyHasRecentCampaignCreate
       * @request POST:/monitoring-service/auth/v1/property-has-recent-campaign/{propertyId}
       */
      authV1PropertyHasRecentCampaignCreate: (t, e = {}) => this.http.request({
        path: `/monitoring-service/auth/v1/property-has-recent-campaign/${t}`,
        method: "POST",
        ...e
      })
    });
    r(this, "name", {});
    this.http = t;
  }
};
const Je = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Ot,
  ContentType: L
}, Symbol.toStringTag, { value: "Module" }));
var w = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(w || {});
let Et = class {
  constructor(t) {
    r(this, "http");
    r(this, "hqSettings", {
      /**
       * No description
       *
       * @tags HqSettings
       * @name AuthV1HqSettingsUploadHqLogoCreate
       * @request POST:/customer-portal-service/auth/v1/hq-settings/upload-hq-logo
       */
      authV1HqSettingsUploadHqLogoCreate: (t, e = {}) => this.http.request({
        path: "/customer-portal-service/auth/v1/hq-settings/upload-hq-logo",
        method: "POST",
        body: t,
        type: "multipart/form-data",
        ...e
      }),
      authV1HqSettingsAddCreate: (t, e = {}) => this.http.request({
        path: "/customer-portal-service/auth/v1/hq-settings/add",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1HqSettingsGetDetail: (t, e = {}) => this.http.request({
        path: `/customer-portal-service/auth/v1/hq-settings/get/${t}`,
        method: "GET",
        format: "json",
        ...e
      })
    });
    r(this, "integrationRequest", {
      /**
       * No description
       *
       * @tags IntegrationRequest
       * @name AuthV1IntegrationRequestCreate
       * @request POST:/customer-portal-service/auth/v1/integration-request
       */
      authV1IntegrationRequestCreate: (t, e = {}) => this.http.request({
        path: "/customer-portal-service/auth/v1/integration-request",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      })
    });
    r(this, "userEvents", {
      /**
       * No description
       *
       * @tags UserEvent
       * @name AuthV1UserEventsCreate
       * @request POST:/customer-portal-service/auth/v1/user-events
       */
      authV1UserEventsCreate: (t, e = {}) => this.http.request({
        path: "/customer-portal-service/auth/v1/user-events",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      publicV1UserEventsCreate: (t, e = {}) => this.http.request({
        path: "/customer-portal-service/public/v1/user-events",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      })
    });
    this.http = t;
  }
};
const Qe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Et,
  ContentType: w
}, Symbol.toStringTag, { value: "Module" }));
var x = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(x || {});
let Ct = class {
  constructor(t) {
    r(this, "http");
    r(this, "agent", {
      /**
       * No description
       *
       * @tags Agent
       * @name AuthV1AgentListList
       * @request GET:/account-manager-service/auth/v1/agent/list
       * @secure
       */
      authV1AgentListList: (t = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/agent/list",
        method: "GET",
        secure: !0,
        ...t
      }),
      authV1AgentRelationsDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}/relations`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1AgentConfigurationDetail: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}/configuration/${e}`,
        method: "GET",
        secure: !0,
        ...a
      }),
      authV1AgentCreate: (t, e = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/agent",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1AgentConfigurationCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}/configuration`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1AgentConfigurationPartialUpdate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}/configuration`,
        method: "PATCH",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1AgentAddToOfficeCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}/add-to-office/${e}`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV1AgentAddToOfficeStartCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}/add-to-office/${e}/start`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV1AgentAddToOfficeConfirmUpdate: (t, e, a, s = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}/add-to-office/${e}/confirm`,
        method: "PUT",
        body: a,
        secure: !0,
        type: "application/json",
        ...s
      }),
      authV1AgentAddToTeamStartCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}/add-to-team/${e}/start`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV1AgentAddToTeamConfimCreate: (t, e, a, s = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}/add-to-team/${e}/confim`,
        method: "POST",
        body: a,
        secure: !0,
        type: "application/json",
        ...s
      }),
      authV1AgentUpdate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}/${e}`,
        method: "PUT",
        secure: !0,
        ...a
      }),
      authV1AgentRemoveFromOfficeDelete: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}/remove-from-office/${e}`,
        method: "DELETE",
        secure: !0,
        ...a
      }),
      authV1AgentRemoveFromTeamDelete: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}/remove-from-team/${e}`,
        method: "DELETE",
        secure: !0,
        ...a
      }),
      authV1AgentDelete: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/agent/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      })
    });
    r(this, "entity", {});
    r(this, "hq", {
      /**
       * No description
       *
       * @tags Hq
       * @name AuthV1HqListList
       * @request GET:/account-manager-service/auth/v1/hq/list
       * @secure
       */
      authV1HqListList: (t = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/hq/list",
        method: "GET",
        secure: !0,
        ...t
      }),
      authV1HqListOfficeClustersDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq/list/${t}/office-clusters`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1HqListOfficesDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq/list/${t}/offices`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1HqRelationsDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq/${t}/relations`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1HqConfigurationDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq/${t}/configuration`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1HqConfigurationCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq/${t}/configuration`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1HqConfigurationPartialUpdate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq/${t}/configuration`,
        method: "PATCH",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1HqConfigurationSearchCreate: (t, e = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/hq/configuration/search",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1HqCreate: (t, e = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/hq",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1HqAddToHqGroupCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq/${t}/add-to-hq-group/${e}`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV1HqAddToHqGroupStartCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq/${t}/add-to-hq-group/${e}/start`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV1HqAddToHqGroupConfirmUpdate: (t, e, a, s = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq/${t}/add-to-hq-group/${e}/confirm`,
        method: "PUT",
        body: a,
        secure: !0,
        type: "application/json",
        ...s
      }),
      authV1HqUpdate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq/${t}/${e}`,
        method: "PUT",
        secure: !0,
        ...a
      }),
      authV1HqRemoveFromHqGroupDelete: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq/${t}/remove-from-hq-group/${e}`,
        method: "DELETE",
        secure: !0,
        ...a
      }),
      authV1HqDelete: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      })
    });
    r(this, "hqGroup", {
      /**
       * No description
       *
       * @tags HqGroup
       * @name AuthV1HqGroupListList
       * @request GET:/account-manager-service/auth/v1/hq-group/list
       * @secure
       */
      authV1HqGroupListList: (t = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/hq-group/list",
        method: "GET",
        secure: !0,
        ...t
      }),
      authV1HqGroupListHqsDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq-group/list/${t}/hqs`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1HqGroupRelationsDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq-group/${t}/relations`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1HqGroupConfigurationDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq-group/${t}/configuration`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1HqGroupConfigurationCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq-group/${t}/configuration`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1HqGroupConfigurationPartialUpdate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq-group/${t}/configuration`,
        method: "PATCH",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1HqGroupCreate: (t, e = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/hq-group",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1HqGroupUpdate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq-group/${t}/${e}`,
        method: "PUT",
        secure: !0,
        ...a
      }),
      authV1HqGroupDelete: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/hq-group/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      })
    });
    r(this, "office", {
      /**
       * No description
       *
       * @tags Office
       * @name AuthV1OfficeListList
       * @request GET:/account-manager-service/auth/v1/office/list
       * @secure
       */
      authV1OfficeListList: (t = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/office/list",
        method: "GET",
        secure: !0,
        ...t
      }),
      authV1OfficeListTeamsDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/list/${t}/teams`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1OfficeListAgentsDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/list/${t}/agents`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1OfficeRelationsDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}/relations`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1OfficeConfigurationDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}/configuration`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1OfficeConfigurationCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}/configuration`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1OfficeConfigurationPartialUpdate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}/configuration`,
        method: "PATCH",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1OfficeCreate: (t, e = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/office",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1OfficeAddToHqCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}/add-to-hq/${e}`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV1OfficeAddToHqStartCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}/add-to-hq/${e}/start`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV1OfficeAddToHqConfirmUpdate: (t, e, a, s = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}/add-to-hq/${e}/confirm`,
        method: "PUT",
        body: a,
        secure: !0,
        type: "application/json",
        ...s
      }),
      authV1OfficeAddToOfficeClusterStartCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}/add-to-office-cluster/${e}/start`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV1OfficeAddToOfficeClusterConfirmUpdate: (t, e, a, s = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}/add-to-office-cluster/${e}/confirm`,
        method: "PUT",
        body: a,
        secure: !0,
        type: "application/json",
        ...s
      }),
      authV1OfficeUpdate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}/${e}`,
        method: "PUT",
        secure: !0,
        ...a
      }),
      authV1OfficeRemoveFromOfficeClusterDelete: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}/remove-from-office-cluster/${e}`,
        method: "DELETE",
        secure: !0,
        ...a
      }),
      authV1OfficeRemoveFromHqDelete: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}/remove-from-hq/${e}`,
        method: "DELETE",
        secure: !0,
        ...a
      }),
      authV1OfficeDelete: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      })
    });
    r(this, "officeCluster", {
      /**
       * No description
       *
       * @tags OfficeCluster
       * @name AuthV1OfficeClusterListList
       * @request GET:/account-manager-service/auth/v1/office-cluster/list
       * @secure
       */
      authV1OfficeClusterListList: (t = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/office-cluster/list",
        method: "GET",
        secure: !0,
        ...t
      }),
      authV1OfficeClusterListOfficesDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office-cluster/list/${t}/offices`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1OfficeClusterRelationsDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office-cluster/${t}/relations`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1OfficeClusterConfigurationDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office-cluster/${t}/configuration`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1OfficeClusterConfigurationCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office-cluster/${t}/configuration`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1OfficeClusterConfigurationPartialUpdate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office-cluster/${t}/configuration`,
        method: "PATCH",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1OfficeClusterCreate: (t, e = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/office-cluster",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1OfficeClusterAddToHqCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office-cluster/${t}/add-to-hq/${e}`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV1OfficeClusterAddToHqStartCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office-cluster/${t}/add-to-hq/${e}/start`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV1OfficeClusterAddToHqConfirmUpdate: (t, e, a, s = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office-cluster/${t}/add-to-hq/${e}/confirm`,
        method: "PUT",
        body: a,
        secure: !0,
        type: "application/json",
        ...s
      }),
      authV1OfficeClusterUpdate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office-cluster/${t}/${e}`,
        method: "PUT",
        secure: !0,
        ...a
      }),
      authV1OfficeClusterRemoveFromHqDelete: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office-cluster/${t}/remove-from-hq/${e}`,
        method: "DELETE",
        secure: !0,
        ...a
      }),
      authV1OfficeClusterDelete: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/office-cluster/${t}`,
        method: "DELETE",
        secure: !0,
        ...e
      })
    });
    r(this, "setup", {
      /**
       * No description
       *
       * @tags Setup
       * @name AuthV1SetupConfigurationSectionsList
       * @request GET:/account-manager-service/auth/v1/setup/configuration-sections
       * @secure
       */
      authV1SetupConfigurationSectionsList: (t = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/setup/configuration-sections",
        method: "GET",
        secure: !0,
        ...t
      }),
      authV1SetupConfigurationSectionsCreate: (t, e = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/setup/configuration-sections",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1SetupConfigurationSectionsKeysDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/setup/configuration-sections/${t}/keys`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1SetupEntityTypesList: (t = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/setup/entity-types",
        method: "GET",
        secure: !0,
        ...t
      }),
      authV1SetupEntityTypesRelationsList: (t = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/setup/entity-types/relations",
        method: "GET",
        secure: !0,
        ...t
      })
    });
    r(this, "team", {
      /**
       * No description
       *
       * @tags Team
       * @name AuthV1TeamListList
       * @request GET:/account-manager-service/auth/v1/team/list
       * @secure
       */
      authV1TeamListList: (t = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/team/list",
        method: "GET",
        secure: !0,
        ...t
      }),
      authV1TeamListAgentsDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/team/list/${t}/agents`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1TeamRelationsDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/team/${t}/relations`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1TeamConfigurationDetail: (t, e = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/team/${t}/configuration`,
        method: "GET",
        secure: !0,
        ...e
      }),
      authV1TeamConfigurationCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/team/${t}/configuration`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1TeamConfigurationPartialUpdate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/team/${t}/configuration`,
        method: "PATCH",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1TeamCreate: (t, e = {}) => this.http.request({
        path: "/account-manager-service/auth/v1/team",
        method: "POST",
        body: t,
        secure: !0,
        type: "application/json",
        ...e
      }),
      authV1TeamAddToOfficeCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/team/${t}/add-to-office/${e}`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV1TeamAddToOfficeStartCreate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/team/${t}/add-to-office/${e}/start`,
        method: "POST",
        secure: !0,
        ...a
      }),
      authV1TeamAddToOfficeConfirmUpdate: (t, e, a, s = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/team/${t}/add-to-office/${e}/confirm`,
        method: "PUT",
        body: a,
        secure: !0,
        type: "application/json",
        ...s
      }),
      authV1TeamUpdate: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/team/${t}/${e}`,
        method: "PUT",
        secure: !0,
        ...a
      }),
      authV1TeamRemoveFromOfficeDelete: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/team/${t}/remove-from-office/${e}`,
        method: "DELETE",
        secure: !0,
        ...a
      }),
      authV1TeamDelete: (t, e, a = {}) => this.http.request({
        path: `/account-manager-service/auth/v1/team/${t}`,
        method: "DELETE",
        query: e,
        secure: !0,
        ...a
      })
    });
    this.http = t;
  }
};
const Ze = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Ct,
  ContentType: x
}, Symbol.toStringTag, { value: "Module" }));
var R = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(R || {});
let Dt = class {
  constructor(t) {
    r(this, "http");
    r(this, "image", {
      /**
       * No description
       *
       * @tags Image
       * @name AuthV1ImageReferenceCreate
       * @request POST:/media-service/auth/v1/image/reference
       */
      authV1ImageReferenceCreate: (t, e = {}) => this.http.request({
        path: "/media-service/auth/v1/image/reference",
        method: "POST",
        body: t,
        type: "application/json",
        ...e
      }),
      authV1ImageGetUploadedImageCreate: (t, e = {}) => this.http.request({
        path: "/media-service/auth/v1/image/get-uploaded-image",
        method: "POST",
        body: t,
        type: "application/json",
        format: "json",
        ...e
      })
    });
    this.http = t;
  }
};
const Xe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Dt,
  ContentType: R
}, Symbol.toStringTag, { value: "Module" }));
var _ = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(_ || {});
let Ut = class {
  constructor(t) {
    r(this, "http");
    /**
     * No description
     *
     * @tags PropertyDescription
     * @name V1PropertyCreate
     * @request POST:/openai-service/v1/property
     */
    r(this, "v1PropertyCreate", (t, e = {}) => this.http.request({
      path: "/openai-service/v1/property",
      method: "POST",
      body: t,
      type: "application/json",
      ...e
    }));
    /**
     * No description
     *
     * @tags UrlAdGeneration
     * @name V1UrlCreate
     * @request POST:/openai-service/v1/url
     */
    r(this, "v1UrlCreate", (t, e = {}) => this.http.request({
      path: "/openai-service/v1/url",
      method: "POST",
      body: t,
      type: "application/json",
      ...e
    }));
    this.http = t;
  }
};
const ta = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Ut,
  ContentType: _
}, Symbol.toStringTag, { value: "Module" }));
var I = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(I || {});
let At = class {
  constructor(t) {
    r(this, "http");
    r(this, "testAuditLog", {});
    r(this, "source", {});
    this.http = t;
  }
};
const aa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: At,
  ContentType: I
}, Symbol.toStringTag, { value: "Module" }));
var F = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(F || {});
let Gt = class {
  constructor(t) {
    r(this, "http");
    this.http = t;
  }
};
const ia = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Gt,
  ContentType: F
}, Symbol.toStringTag, { value: "Module" }));
var M = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(M || {});
let Ht = class {
  constructor(t) {
    r(this, "http");
    r(this, "import", {});
    this.http = t;
  }
};
const oa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Ht,
  ContentType: M
}, Symbol.toStringTag, { value: "Module" }));
var B = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(B || {});
let kt = class {
  constructor(t) {
    r(this, "http");
    r(this, "hqId", {
      /**
       * No description
       *
       * @tags CustomerFeed
       * @name AuthV1CustomerFeedDetail
       * @request GET:/customer-api-integration-service/auth/v1/{hqId}/customer-feed
       * @secure
       */
      authV1CustomerFeedDetail: (t, e, a = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/customer-feed`,
        method: "GET",
        query: e,
        secure: !0,
        format: "json",
        ...a
      }),
      authV1CustomerFeedExampleDetail: (t, e = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/customer-feed/example`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1HqSettingsDetail: (t, e = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/hq-settings`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1HqSettingsCreate: (t, e, a = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/hq-settings`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1MetaDataDetail: (t, e = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/meta-data`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "import", {});
    r(this, "metaData", {
      /**
       * No description
       *
       * @tags MetaData
       * @name AuthV1MetaDataList
       * @request GET:/customer-api-integration-service/auth/v1/meta-data
       * @secure
       */
      authV1MetaDataList: (t = {}) => this.http.request({
        path: "/customer-api-integration-service/auth/v1/meta-data",
        method: "GET",
        secure: !0,
        format: "json",
        ...t
      })
    });
    this.http = t;
  }
};
const pa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: kt,
  ContentType: B
}, Symbol.toStringTag, { value: "Module" }));
var z = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(z || {});
let Lt = class {
  constructor(t) {
    r(this, "http");
    r(this, "login", {
      /**
       * No description
       *
       * @tags Login
       * @name AuthV1LoginTestList
       * @request GET:/realmedia-core-service/auth/v1/login/test
       * @secure
       */
      authV1LoginTestList: (t = {}) => this.http.request({
        path: "/realmedia-core-service/auth/v1/login/test",
        method: "GET",
        secure: !0,
        ...t
      }),
      authV1LoginPhoenixDetail: (t, e = {}) => this.http.request({
        path: `/realmedia-core-service/auth/v1/login/phoenix/${t}`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    this.http = t;
  }
};
const na = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Lt,
  ContentType: z
}, Symbol.toStringTag, { value: "Module" }));
var J = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(J || {});
let wt = class {
  constructor(t) {
    r(this, "http");
    r(this, "hqId", {
      /**
       * No description
       *
       * @tags CustomerFeed
       * @name AuthV1CustomerFeedDetail
       * @request GET:/customer-api-integration-service/auth/v1/{hqId}/customer-feed
       * @secure
       */
      authV1CustomerFeedDetail: (t, e, a = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/customer-feed`,
        method: "GET",
        query: e,
        secure: !0,
        format: "json",
        ...a
      }),
      authV1CustomerFeedExampleDetail: (t, e = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/customer-feed/example`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1HqSettingsDetail: (t, e = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/hq-settings`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1HqSettingsCreate: (t, e, a = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/hq-settings`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1MetaDataDetail: (t, e = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/meta-data`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "metaData", {
      /**
       * No description
       *
       * @tags MetaData
       * @name AuthV1MetaDataList
       * @request GET:/customer-api-integration-service/auth/v1/meta-data
       * @secure
       */
      authV1MetaDataList: (t = {}) => this.http.request({
        path: "/customer-api-integration-service/auth/v1/meta-data",
        method: "GET",
        secure: !0,
        format: "json",
        ...t
      })
    });
    this.http = t;
  }
};
const ma = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: wt,
  ContentType: J
}, Symbol.toStringTag, { value: "Module" }));
var W = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(W || {});
let xt = class {
  constructor(t) {
    r(this, "http");
    r(this, "hqId", {
      /**
       * No description
       *
       * @tags CustomerFeed
       * @name AuthV1CustomerFeedDetail
       * @request GET:/customer-api-integration-service/auth/v1/{hqId}/customer-feed
       * @secure
       */
      authV1CustomerFeedDetail: (t, e, a = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/customer-feed`,
        method: "GET",
        query: e,
        secure: !0,
        format: "json",
        ...a
      }),
      authV1CustomerFeedExampleDetail: (t, e = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/customer-feed/example`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1HqSettingsDetail: (t, e = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/hq-settings`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1HqSettingsCreate: (t, e, a = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/hq-settings`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1MetaDataDetail: (t, e = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/meta-data`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "import", {});
    r(this, "metaData", {
      /**
       * No description
       *
       * @tags MetaData
       * @name AuthV1MetaDataList
       * @request GET:/customer-api-integration-service/auth/v1/meta-data
       * @secure
       */
      authV1MetaDataList: (t = {}) => this.http.request({
        path: "/customer-api-integration-service/auth/v1/meta-data",
        method: "GET",
        secure: !0,
        format: "json",
        ...t
      })
    });
    this.http = t;
  }
};
const la = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: xt,
  ContentType: W
}, Symbol.toStringTag, { value: "Module" }));
var Q = /* @__PURE__ */ ((i) => (i.Json = "application/json", i.FormData = "multipart/form-data", i.UrlEncoded = "application/x-www-form-urlencoded", i.Text = "text/plain", i))(Q || {});
class Rt {
  constructor(t) {
    r(this, "http");
    r(this, "hqId", {
      /**
       * No description
       *
       * @tags CustomerFeed
       * @name AuthV1CustomerFeedDetail
       * @request GET:/customer-api-integration-service/auth/v1/{hqId}/customer-feed
       * @secure
       */
      authV1CustomerFeedDetail: (t, e, a = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/customer-feed`,
        method: "GET",
        query: e,
        secure: !0,
        format: "json",
        ...a
      }),
      authV1CustomerFeedExampleDetail: (t, e = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/customer-feed/example`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1HqSettingsDetail: (t, e = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/hq-settings`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      }),
      authV1HqSettingsCreate: (t, e, a = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/hq-settings`,
        method: "POST",
        body: e,
        secure: !0,
        type: "application/json",
        ...a
      }),
      authV1MetaDataDetail: (t, e = {}) => this.http.request({
        path: `/customer-api-integration-service/auth/v1/${t}/meta-data`,
        method: "GET",
        secure: !0,
        format: "json",
        ...e
      })
    });
    r(this, "import", {});
    r(this, "metaData", {
      /**
       * No description
       *
       * @tags MetaData
       * @name AuthV1MetaDataList
       * @request GET:/customer-api-integration-service/auth/v1/meta-data
       * @secure
       */
      authV1MetaDataList: (t = {}) => this.http.request({
        path: "/customer-api-integration-service/auth/v1/meta-data",
        method: "GET",
        secure: !0,
        format: "json",
        ...t
      })
    });
    this.http = t;
  }
}
const ga = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: Rt,
  ContentType: Q
}, Symbol.toStringTag, { value: "Module" }));
export {
  Ze as AccountManagerService,
  ve as AgentService,
  qe as AnalyticsService,
  aa as AuditLogService,
  Ft as AuthService,
  je as BillingService,
  le as CampaignService,
  la as ChestnutParkIntegrationService,
  Bt as ConfigurationService,
  Ve as CurrencyConversion,
  ma as CustomerApiIntegrationService,
  Qe as CustomerPortalService,
  ne as DisplayAdsService,
  pe as EmailService,
  Jt as FacebookService,
  He as GeoService,
  Le as GetScriptsService,
  oa as IdcglobalIntegrationService,
  ia as IntegrationService,
  ae as LeadService,
  Xe as MediaService,
  Je as MonitoringService,
  ta as OpenAIService,
  Te as OrderService,
  _e as ProgramService,
  me as PropertyDiscoveryService,
  Be as PropertyEventService,
  te as PropertyService,
  Fe as QuedroIntegrationService,
  xe as ReadLayer,
  Pe as RealforceAPI,
  na as RealmediaCoreService,
  ga as RelianceIntegrationService,
  oe as ReportingService,
  Ee as SchedulerService,
  De as SellerService,
  ie as StripeService,
  Ae as TaxService,
  Qt as TemplateService,
  pa as TribusIntegrationService,
  Zt as UrlValidationService,
  Xt as ZendeskService
};
